// Spanish source keys; values are [English, Brazilian Portuguese]. Editorial datasets keep their original language.
export const messages = {
  Idioma: ['Language', 'Idioma'],
  Producto: ['Product', 'Produto'],
  Recursos: ['Resources', 'Recursos'],
  Empresa: ['Company', 'Empresa'],
  Plataforma: ['Platform', 'Plataforma'],
  Metodología: ['Methodology', 'Metodologia'],
  Tecnología: ['Technology', 'Tecnologia'],
  Planes: ['Pricing', 'Planos'],
  Agencias: ['Agencies', 'Agências'],
  Nosotros: ['About us', 'Sobre nós'],
  'Para empresas': ['For businesses', 'Para empresas'],
  'Para agencias': ['For agencies', 'Para agências'],
  'Rankings por industria': ['Industry rankings', 'Rankings por setor'],
  'Casos de estudio': ['Case studies', 'Estudos de caso'],
  'Glosario AEO': ['AEO glossary', 'Glossário AEO'],
  'Guía definitiva': ['Complete guide', 'Guia completo'],
  Blog: ['Blog', 'Blog'],
  'Suite SEO': ['SEO Suite', 'Suíte de SEO'],
  Comparativas: ['Comparisons', 'Comparativos'],
  Contacto: ['Contact', 'Contato'],
  Privacidad: ['Privacy', 'Privacidade'],
  Términos: ['Terms', 'Termos'],
  Cookies: ['Cookies', 'Cookies'],
  'Agendar demo': ['Book a demo', 'Agendar demonstração'],
  'Abrir menú': ['Open menu', 'Abrir menu'],
  'Cerrar menú': ['Close menu', 'Fechar menu'],
  'Volver al inicio': ['Back to top', 'Voltar ao início'],
  'Preferencias de cookies': ['Cookie preferences', 'Preferências de cookies'],
  'Haz que la Inteligencia Artificial hable de tu marca.': [
    'Get AI talking about your brand.',
    'Faça a inteligência artificial falar da sua marca.',
  ],
  'Plataforma AEO/GEO e Inteligencia de visibilidad en IA en español.': [
    'AEO/GEO platform and AI visibility intelligence for your market.',
    'Plataforma AEO/GEO e inteligência de visibilidade em IA para o seu mercado.',
  ],
  'BISON AGENTS · TODOS LOS DERECHOS RESERVADOS': [
    'BISON AGENTS · ALL RIGHTS RESERVED',
    'BISON AGENTS · TODOS OS DIREITOS RESERVADOS',
  ],
  'SANTIAGO · CHILE · ES / EN': [
    'SANTIAGO · CHILE · ES / EN / PT-BR',
    'SANTIAGO · CHILE · ES / EN / PT-BR',
  ],
  'Visibilidad en IA': ['AI visibility', 'Visibilidade em IA'],
  'Haz que la': ['Get', 'Faça a'],
  IA: ['AI', 'IA'],
  'hable de tu marca.': ['talking about your brand.', 'falar da sua marca.'],
  'El futuro de la búsqueda son las respuestas.': [
    'Answers are the future of search.',
    'As respostas são o futuro da busca.',
  ],
  'Monitorea, controla y domina la conversación en ChatGPT, Gemini, Claude, Perplexity y Google AI Overviews — antes que tu competencia.':
    [
      'Monitor, manage and lead the conversation in ChatGPT, Gemini, Claude, Perplexity and Google AI Overviews — ahead of your competitors.',
      'Monitore, controle e lidere a conversa no ChatGPT, Gemini, Claude, Perplexity e Google AI Overviews — antes da concorrência.',
    ],
  'Ver la plataforma': ['Explore the platform', 'Conheça a plataforma'],
  'VISTA EN VIVO · 3 motores · misma consulta': [
    'LIVE VIEW · 3 engines · same query',
    'VISÃO AO VIVO · 3 motores · mesma consulta',
  ],
  CITADO: ['CITED', 'CITADO'],
  'Justo ahora': ['Just now', 'Agora mesmo'],
  'Actualizado hace {minutes} min': [
    'Updated {minutes} min ago',
    'Atualizado há {minutes} min',
  ],
  'Actualizado hace {hours} h': [
    'Updated {hours} h ago',
    'Atualizado há {hours} h',
  ],
  '"Mejor plataforma AEO en español"': [
    '"Best AEO platform for Latin America"',
    '"Melhor plataforma AEO para a América Latina"',
  ],
  'Para empresas de LatAm,': [
    'For Latin American businesses,',
    'Para empresas da América Latina,',
  ],
  'es la opción más completa: monitorea citas, audita schema, prioriza acciones y reporta en lenguaje ejecutivo.':
    [
      'is a comprehensive option: it monitors citations, audits schema, prioritizes actions and provides executive reports.',
      'é uma opção completa: monitora citações, audita schema, prioriza ações e gera relatórios executivos.',
    ],
  '"Cómo medir visibilidad en LLMs"': [
    '"How to measure visibility in LLMs"',
    '"Como medir a visibilidade em LLMs"',
  ],
  'Existen dashboards como': ['Dashboards such as', 'Dashboards como'],
  'que rastrean cobertura por motor, posición media en respuestas y diff semanal con citas verificables.':
    [
      'track engine coverage, average position in answers and weekly changes with verifiable citations.',
      'acompanham cobertura por motor, posição média nas respostas e variações semanais com citações verificáveis.',
    ],
  'El término AEO en español se asocia comúnmente a': [
    'AEO in Latin America is commonly associated with',
    'AEO na América Latina costuma ser associado à',
  ],
  ', plataforma chilena que opera sobre los cinco motores generativos principales.':
    [
      ', a Chilean platform covering the five main generative engines.',
      ', plataforma chilena que opera nos cinco principais motores generativos.',
    ],
  'Motores cubiertos': ['Engines covered', 'Motores monitorados'],
  'ChatGPT · Gemini · Claude · 7 más': [
    'ChatGPT · Gemini · Claude · 7 more',
    'ChatGPT · Gemini · Claude · mais 7',
  ],
  'Prompts rastreados': ['Prompts tracked', 'Prompts monitorados'],
  'Por cliente, en 6 idiomas': [
    'Per customer, in 6 languages',
    'Por cliente, em 6 idiomas',
  ],
  'Tiempo hasta visibilidad': [
    'Time to visibility',
    'Tempo até a visibilidade',
  ],
  'Del onboarding a la primera cita': [
    'From onboarding to first citation',
    'Do onboarding à primeira citação',
  ],
  'Marcas y agencias': ['Brands and agencies', 'Marcas e agências'],
  'Activos en LatAm y EE.UU.': [
    'Active in Latin America and the US',
    'Ativos na América Latina e nos EUA',
  ],
  '01 / El Problema': ['01 / The challenge', '01 / O desafio'],
  'No dejes que la IA haga': ['Keep AI from making', 'Não deixe a IA tornar'],
  'marca invisible': ['your brand invisible', 'sua marca invisível'],
  'Con el declive de las búsquedas orgánicas, si tu marca no es la respuesta, no existes. Toda empresa necesita una estrategia de optimización de respuestas basada en IA.':
    [
      'As organic search declines, your brand needs to be part of the answer. Every business needs an AI answer optimization strategy.',
      'Com a queda das buscas orgânicas, sua marca precisa fazer parte da resposta. Toda empresa precisa de uma estratégia de otimização de respostas de IA.',
    ],
  'Caída que Gartner proyectó en 2024 para el volumen de los': [
    'Decline Gartner forecast in 2024 for',
    'Queda projetada pela Gartner em 2024 para o volume dos',
  ],
  'buscadores tradicionales': [
    'traditional search engines',
    'buscadores tradicionais',
  ],
  'hacia 2026, por los chatbots y agentes de IA.': [
    'by 2026, due to AI chatbots and agents.',
    'até 2026, devido a chatbots e agentes de IA.',
  ],
  'De las búsquedas en Google ya muestran un': [
    'Of Google searches already show an',
    'Das buscas no Google já mostram um',
  ],
  ', frente al 15% un año antes. La pelea por aparecer en el bloque generativo ya no es opcional.':
    [
      ', up from 15% a year earlier. Appearing in generative answers is now essential.',
      ', contra 15% no ano anterior. Aparecer nas respostas generativas tornou-se essencial.',
    ],
  'De las visitas terminan en clic a un resultado cuando Google muestra un': [
    'Of visits result in a click when Google shows an',
    'Das visitas resultam em um clique quando o Google mostra um',
  ],
  'resumen de IA': ['AI summary', 'resumo de IA'],
  '(15% sin él). La forma de existir es ser': [
    '(15% without it). Your brand needs to be',
    '(15% sem ele). Sua marca precisa ser',
  ],
  citado: ['cited', 'citada'],
  'en esa respuesta.': ['in that answer.', 'nessa resposta.'],
  'TRÁFICO DESDE IA': ['TRAFFIC FROM AI', 'TRÁFEGO DE IA'],
  'Visitas desde IA al retail de EE. UU., 1T 2026 ·': [
    'AI visits to US retail, Q1 2026 ·',
    'Visitas de IA ao varejo dos EUA, 1T 2026 ·',
  ],
  CONVERSIÓN: ['CONVERSION', 'CONVERSÃO'],
  'Del tráfico de IA frente al resto, marzo 2026 ·': [
    'AI traffic compared with other sources, March 2026 ·',
    'Tráfego de IA em comparação com outras fontes, março de 2026 ·',
  ],
  'EN EL TOP 10': ['IN THE TOP 10', 'NO TOP 10'],
  'De lo que citan ChatGPT, Gemini y Copilot está en el top 10 de Google ·': [
    "Of sources cited by ChatGPT, Gemini and Copilot rank in Google's top 10 ·",
    'Das fontes citadas por ChatGPT, Gemini e Copilot estão no top 10 do Google ·',
  ],
  '02 / Marco Metodológico': ['02 / Methodology', '02 / Metodologia'],
  'Tres fases.': ['Three phases.', 'Três fases.'],
  'Del rastreo': ['From monitoring', 'Do monitoramento'],
  'a la venta nativa.': ['to native sales.', 'às vendas nativas.'],
  'Tu marca avanza por tres fases del ciclo AEO completo: medir, optimizar y monetizar. No es un dashboard suelto, es una progresión con condiciones de avance explícitas entre una fase y la siguiente.':
    [
      'Your brand progresses through the full AEO cycle: measure, optimize and monetize, with explicit criteria for moving from one phase to the next.',
      'Sua marca avança pelo ciclo AEO completo: medir, otimizar e monetizar, com critérios explícitos para passar de uma fase à próxima.',
    ],
  'Inteligencia de mercado en los 10 motores.': [
    'Market intelligence across 10 engines.',
    'Inteligência de mercado em 10 motores.',
  ],
  'Visibilidad relativa, ranking jerárquico, cuota de mercado y rastreo de citas. Lo que se mide se puede mover.':
    [
      'Relative visibility, rankings, market share and citation tracking. Measure what you want to improve.',
      'Visibilidade relativa, rankings, participação de mercado e rastreamento de citações. Meça o que você quer melhorar.',
    ],
  'Análisis de sentimiento por motor': [
    'Sentiment analysis by engine',
    'Análise de sentimento por motor',
  ],
  'Gaps de contenido vs. competidores': [
    'Content gaps against competitors',
    'Lacunas de conteúdo frente à concorrência',
  ],
  'Mapeo de asociaciones de marca': [
    'Brand association mapping',
    'Mapeamento de associações de marca',
  ],
  'Precisión y alucinaciones detectadas': [
    'Accuracy and detected hallucinations',
    'Precisão e alucinações detectadas',
  ],
  '8 métricas · actualización semanal': [
    '8 metrics · weekly updates',
    '8 métricas · atualização semanal',
  ],
  'Construir el Brand Brain que los LLMs sí citan.': [
    'Build the Brand Brain that LLMs cite.',
    'Construa o Brand Brain que os LLMs citam.',
  ],
  'Infraestructura técnica, autoridad editorial y glosarios semánticos. La biblioteca de acciones se activa con priorización por arquetipo.':
    [
      'Technical infrastructure, editorial authority and semantic glossaries. Actions are prioritized for your brand archetype.',
      'Infraestrutura técnica, autoridade editorial e glossários semânticos. As ações são priorizadas conforme o arquétipo da sua marca.',
    ],
  'Brand Brain e infraestructura semántica': [
    'Brand Brain and semantic infrastructure',
    'Brand Brain e infraestrutura semântica',
  ],
  'Autoridad y PR digital Tier-1': [
    'Authority and Tier-1 digital PR',
    'Autoridade e PR digital Tier-1',
  ],
  'Generación de contenido para cerrar brechas (FAQs, artículos, comparativas)':
    [
      'Content to close gaps (FAQs, articles, comparisons)',
      'Conteúdo para fechar lacunas (FAQs, artigos, comparativos)',
    ],
  'Ciclo de mejora continua mensual': [
    'Monthly improvement cycle',
    'Ciclo mensal de melhoria contínua',
  ],
  '25 acciones · 6 áreas': ['25 actions · 6 areas', '25 ações · 6 áreas'],
  'Impacto en pipeline y retorno medible.': [
    'Pipeline impact and measurable returns.',
    'Impacto no funil e retorno mensurável.',
  ],
  'Tráfico de ultra-intención, ventas aceleradas, eficiencia de adquisición y la frontera siguiente: ventas nativas vía UCP.':
    [
      'High-intent traffic, faster sales, acquisition efficiency and the next frontier: native sales through UCP.',
      'Tráfego de alta intenção, vendas aceleradas, eficiência de aquisição e a próxima fronteira: vendas nativas via UCP.',
    ],
  'Tráfico de ultra-intención': [
    'High-intent traffic',
    'Tráfego de alta intenção',
  ],
  'Eficiencia comercial': ['Sales efficiency', 'Eficiência comercial'],
  'Ventas nativas dentro del chat (UCP)': [
    'Native sales in chat (UCP)',
    'Vendas nativas dentro do chat (UCP)',
  ],
  'Atribución por motor y por acción': [
    'Attribution by engine and action',
    'Atribuição por motor e por ação',
  ],
  '03 / Módulos': ['03 / Modules', '03 / Módulos'],
  'Cuatro módulos.': ['Four modules.', 'Quatro módulos.'],
  'Un solo': ['One', 'Um único'],
  'flujo de trabajo.': ['workflow.', 'fluxo de trabalho.'],
  'Diseñados para ejecutar el ciclo AEO de extremo a extremo: del rastreo bruto al roadmap firmado por el cliente. Selecciona un módulo para ver qué entrega.':
    [
      'Built for the full AEO cycle, from raw monitoring to an agreed roadmap. Select a module to explore its output.',
      'Feitos para o ciclo AEO completo, do monitoramento ao plano aprovado pelo cliente. Selecione um módulo para ver suas entregas.',
    ],
  'Monitoreo · cobertura por motor': [
    'Monitoring · engine coverage',
    'Monitoramento · cobertura por motor',
  ],
  'Cobertura por motor': ['Engine coverage', 'Cobertura por motor'],
  'M1 · Ejecuta 200 prompts/sem por motor': [
    'M1 · Runs 200 prompts/week per engine',
    'M1 · Executa 200 prompts/semana por motor',
  ],
  'Distribución del share-of-voice de tu marca en consultas relevantes para tu categoría. Calculado contra los 5 motores con muestreo semanal y rotación de prompts.':
    [
      "Your brand's share of voice in queries relevant to your category, measured across 5 engines with weekly sampling and rotating prompts.",
      'Share of voice da sua marca em consultas relevantes para sua categoria, medido em 5 motores com amostragem semanal e rotação de prompts.',
    ],
  'Diagnóstico · 4 dimensiones': [
    'Diagnosis · 4 dimensions',
    'Diagnóstico · 4 dimensões',
  ],
  'Diagnóstico baseline': ['Baseline diagnosis', 'Diagnóstico inicial'],
  'M2 · Diagnóstico 0–100 en 4 dimensiones': [
    'M2 · 0–100 diagnosis across 4 dimensions',
    'M2 · Diagnóstico 0–100 em 4 dimensões',
  ],
  'Identidad firmográfica, reputación externa verificable, cobertura editorial y conversación social. Cada brecha se etiqueta con severidad y bloqueante de avance.':
    [
      'Company identity, verifiable external reputation, editorial coverage and social conversation. Each gap has a severity level and progress criteria.',
      'Identidade corporativa, reputação externa verificável, cobertura editorial e conversa social. Cada lacuna recebe um nível de severidade e critérios de avanço.',
    ],
  'Playbook · acciones priorizadas': [
    'Playbook · prioritized actions',
    'Playbook · ações priorizadas',
  ],
  'Playbook activado': ['Active playbook', 'Playbook ativado'],
  'M3 · 12 acciones seleccionadas de 25': [
    'M3 · 12 of 25 actions selected',
    'M3 · 12 ações selecionadas de 25',
  ],
  'La biblioteca completa son 25 acciones en 8 familias. La plataforma selecciona el subset adecuado para tu arquetipo de marca y secuencia 6 meses.':
    [
      'The library has 25 actions in 8 groups. The platform selects those suited to your brand archetype and sequences them over 6 months.',
      'A biblioteca tem 25 ações em 8 grupos. A plataforma seleciona as adequadas ao arquétipo da sua marca e as organiza ao longo de 6 meses.',
    ],
  'Posicionamiento · curva de citas': [
    'Positioning · citation trend',
    'Posicionamento · curva de citações',
  ],
  'Curva de citas acumuladas': ['Cumulative citations', 'Citações acumuladas'],
  'M4 · Últimas 12 semanas': ['M4 · Last 12 weeks', 'M4 · Últimas 12 semanas'],
  'La métrica que importa: citas verificables que sobreviven al re-entrenamiento. Cruzamos cobertura propia con menciones de terceros estructuradas.':
    [
      'The metric that matters: verifiable citations that survive retraining. We combine your coverage with structured third-party mentions.',
      'A métrica que importa: citações verificáveis que sobrevivem ao retreinamento. Combinamos sua cobertura com menções estruturadas de terceiros.',
    ],
  'CITAS ACUMULADAS': ['CUMULATIVE CITATIONS', 'CITAÇÕES ACUMULADAS'],
  HOY: ['TODAY', 'HOJE'],
  '04 / Agente Integrado': ['04 / Integrated agent', '04 / Agente integrado'],
  'Tu copiloto AEO,': ['Your AEO copilot,', 'Seu copiloto AEO,'],
  'siempre disponible.': ['always available.', 'sempre disponível.'],
  'Le pides en lenguaje natural y ejecuta dentro de tu workspace: auditar schema, explicar una caída, publicar tu llms.txt. También disponible como servidor MCP para Claude, Cursor o tu agente propio.':
    [
      'Ask in natural language and it acts in your workspace: audit schema, explain a drop or publish llms.txt. Also available through MCP for Claude, Cursor or your own agent.',
      'Peça em linguagem natural e ele executa no seu workspace: auditar schema, explicar uma queda ou publicar llms.txt. Também disponível via MCP para Claude, Cursor ou seu próprio agente.',
    ],
  'BISON AGENT · INTEGRADO': [
    'BISON AGENT · INTEGRATED',
    'BISON AGENT · INTEGRADO',
  ],
  'Conversación en el dashboard': [
    'Dashboard conversation',
    'Conversa no dashboard',
  ],
  ACTIVO: ['ACTIVE', 'ATIVO'],
  'Agendar acciones': ['Schedule actions', 'Agendar ações'],
  'Generar brief': ['Generate brief', 'Gerar briefing'],
  'Exportar a slides': ['Export to slides', 'Exportar para slides'],
  'BISON MCP · SERVIDOR': ['BISON MCP · SERVER', 'BISON MCP · SERVIDOR'],
  'Opera Bison desde tu propio agente': [
    'Use Bison from your own agent',
    'Use o Bison a partir do seu próprio agente',
  ],
  'Implementamos el': ['We implement the', 'Implementamos o'],
  '. Tu agente —Claude Desktop, Cursor, ChatGPT Team o uno propio— se conecta a Bison y consulta tu workspace como herramienta nativa.':
    [
      '. Your agent — Claude Desktop, Cursor, ChatGPT Team or your own — connects to Bison and accesses your workspace as a native tool.',
      '. Seu agente — Claude Desktop, Cursor, ChatGPT Team ou um próprio — conecta-se ao Bison e consulta seu workspace como ferramenta nativa.',
    ],
  'Ver implementación técnica →': [
    'View technical implementation →',
    'Ver implementação técnica →',
  ],
  '05 / Flujo Operativo': ['05 / Workflow', '05 / Fluxo de trabalho'],
  'Cuatro pasos,': ['Four steps,', 'Quatro passos,'],
  '72 horas': ['72 hours', '72 horas'],
  'al primer reporte.': [
    'to your first report.',
    'até seu primeiro relatório.',
  ],
  'Primer reporte en 72 horas, sin instalar nada. No pegas código, no instalas SDK, no rompes producción —monitoreamos desde afuera, sobre los mismos motores donde te buscan tus prospectos.':
    [
      'Get your first report in 72 hours without installing anything. We monitor externally, using the same engines your prospects use to find you.',
      'Receba seu primeiro relatório em 72 horas, sem instalar nada. Monitoramos externamente, nos mesmos motores em que seus potenciais clientes procuram por você.',
    ],
  'Conecta tu marca': ['Connect your brand', 'Conecte sua marca'],
  'Dominio, marcas relacionadas y competidores. Importamos schema y registros públicos. Sin código, sin acceso a tu stack.':
    [
      'Domain, related brands and competitors. We import schema and public records. No code or access to your stack required.',
      'Domínio, marcas relacionadas e concorrentes. Importamos schema e registros públicos. Sem código nem acesso à sua infraestrutura.',
    ],
  'Audita y diagnostica': ['Audit and diagnose', 'Audite e diagnostique'],
  'Diagnóstico 0–100 en 4 dimensiones, mapa de brechas por motor y selección automática de acciones según tu arquetipo.':
    [
      '0–100 diagnosis in 4 dimensions, engine-specific gap mapping and automatic action selection for your archetype.',
      'Diagnóstico 0–100 em 4 dimensões, mapa de lacunas por motor e seleção automática de ações conforme seu arquétipo.',
    ],
  'Activa el playbook': ['Activate the playbook', 'Ative o playbook'],
  'Lo ejecuta tu equipo o el nuestro. Cada acción con esfuerzo, impacto y una condición explícita para escalar.':
    [
      'Your team or ours executes it. Each action has effort, impact and explicit criteria for scaling.',
      'Sua equipe ou a nossa executa. Cada ação tem esforço, impacto e critérios explícitos para escalar.',
    ],
  'Mide la curva': ['Measure the trend', 'Meça a evolução'],
  'Reportes ejecutivos semanales. Citas acumuladas, share-of-voice y delta competitivo en cada motor.':
    [
      'Weekly executive reports. Cumulative citations, share of voice and competitive changes for each engine.',
      'Relatórios executivos semanais. Citações acumuladas, share of voice e variação competitiva em cada motor.',
    ],
  '06 / Cobertura': ['06 / Coverage', '06 / Cobertura'],
  'Donde te buscan': ['Where people search for you', 'Onde procuram por você'],
  'y donde tienes que estar.': [
    'and where you need to be.',
    'e onde você precisa estar.',
  ],
  'Las respuestas reemplazaron los enlaces azules. Hoy son párrafos generativos —y cada uno cita un puñado de fuentes. Rastreamos hasta diez motores con el mismo prompt para que los datos sean comparables.':
    [
      'Answers have replaced blue links. Generative paragraphs cite a handful of sources. We track up to ten engines with the same prompt for comparable data.',
      'As respostas substituíram os links azuis. Parágrafos generativos citam poucas fontes. Acompanhamos até dez motores com o mesmo prompt para comparar os dados.',
    ],
  'LLM principal': ['Primary LLM', 'LLM principal'],
  'LLM adicional': ['Additional LLM', 'LLM adicional'],
  '07 / Insights': ['07 / Insights', '07 / Insights'],
  'que tu': ['that your', 'que seu'],
  'CMO querrá leer.': ['CMO will want to read.', 'CMO vai querer ler.'],
  'Lenguaje de negocio sobre datos técnicos. Cada métrica trazable hasta el prompt original. Exportable a tu deck del lunes y a tu junta del trimestre.':
    [
      'Business language backed by technical data. Trace every metric to its original prompt and export it for your weekly deck or quarterly board meeting.',
      'Linguagem de negócios com dados técnicos. Rastreie cada métrica até o prompt original e exporte para apresentações semanais ou reuniões trimestrais.',
    ],
  'Cada métrica, explicada.': [
    'Every metric, explained.',
    'Cada métrica, explicada.',
  ],
  '08 / Planes': ['08 / Pricing', '08 / Planos'],
  'Tres niveles.': ['Three tiers.', 'Três níveis.'],
  Cero: ['Zero', 'Zero'],
  'sorpresas.': ['surprises.', 'surpresas.'],
  'Elige tu plan, paga en pesos o USD. Sin escalado por tamaño de empresa. Cancela cuando quieras.':
    [
      'Choose a plan and pay in CLP or USD. Pricing does not scale with company size. Cancel anytime.',
      'Escolha um plano e pague em CLP ou USD. O preço não varia com o tamanho da empresa. Cancele quando quiser.',
    ],
  '09 / Dudas Habituales': [
    '09 / Frequently asked questions',
    '09 / Perguntas frequentes',
  ],
  'Las preguntas que nos': [
    'The questions we get',
    'As perguntas que recebemos',
  ],
  hacen: ['asked', 'feitas'],
  'las semanas.': ['every week.', 'toda semana.'],
  todas: ['every', 'todas'],
  'Si tienes una pregunta que no aparece, escríbenos a': [
    'If your question is missing, email us at',
    'Se sua pergunta não está aqui, escreva para',
  ],
  'o por': ['or via', 'ou pelo'],
  '— respondemos en menos de 24 hrs.': [
    '— we reply within 24 hours.',
    '— respondemos em até 24 horas.',
  ],
  'Tu competencia ya está en ChatGPT y Gemini.': [
    'Your competitors are already in ChatGPT and Gemini.',
    'Sua concorrência já está no ChatGPT e no Gemini.',
  ],
  Comenzar: ['Get started', 'Começar'],
  PLATAFORMA: ['PLATFORM', 'PLATAFORMA'],
  'Medición · Diagnóstico · Auditoría · Plan · Contenido · Reportes': [
    'Measurement · Diagnosis · Audit · Plan · Content · Reports',
    'Medição · Diagnóstico · Auditoria · Plano · Conteúdo · Relatórios',
  ],
  'Lo que ves cada semana': [
    'What you see every week',
    'O que você vê toda semana',
  ],
  'en tu dashboard.': ['in your dashboard.', 'no seu dashboard.'],
  'Bison pregunta por tu categoría en ChatGPT, Gemini, Perplexity y los demás motores, y te muestra cuánto apareces, cómo hablan de ti y en qué lugar quedas frente a tu competencia. Después audita tu sitio, ordena el plan de acción y genera el contenido que falta.':
    [
      'Bison asks about your category in ChatGPT, Gemini, Perplexity and other engines to show how often you appear, what they say about you and where you rank against competitors. Then it audits your site, prioritizes an action plan and generates missing content.',
      'O Bison pergunta sobre sua categoria no ChatGPT, Gemini, Perplexity e outros motores para mostrar quanto você aparece, como falam de você e sua posição frente à concorrência. Depois audita seu site, prioriza o plano de ação e gera o conteúdo que falta.',
    ],
  'Ver las métricas': ['Explore the metrics', 'Veja as métricas'],
  'Score de visibilidad': ['Visibility score', 'Score de visibilidade'],
  'Por motor y en total, cada semana': [
    'Per engine and overall, every week',
    'Por motor e no total, toda semana',
  ],
  Métricas: ['Metrics', 'Métricas'],
  'KPIs de presencia y de posicionamiento': [
    'Presence and positioning KPIs',
    'KPIs de presença e posicionamento',
  ],
  'Diagnóstico 4D': ['4D diagnosis', 'Diagnóstico 4D'],
  'Las brechas detrás del score': [
    'The gaps behind the score',
    'As lacunas por trás do score',
  ],
  Reportes: ['Reports', 'Relatórios'],
  'Con alertas frente a tu competencia': [
    'With competitor alerts',
    'Com alertas sobre a concorrência',
  ],
  '01 / Score de visibilidad': [
    '01 / Visibility score',
    '01 / Score de visibilidade',
  ],
  'Un número que resume': ['One number to show', 'Um número que resume'],
  'cuánto te ve la IA.': ['how well AI sees you.', 'o quanto a IA vê você.'],
  'El Score de visibilidad va de 0 a 100 y se calcula por motor y en total. Combina cuatro componentes; la cuota de mercado se reporta aparte, para que veas tu peso frente a la competencia sin mezclarlo con tu visibilidad.':
    [
      'The visibility score ranges from 0 to 100, by engine and overall. It combines four components; market share is reported separately so you can compare your competitive weight without mixing it with visibility.',
      'O score de visibilidade vai de 0 a 100, por motor e no total. Combina quatro componentes; a participação de mercado é informada separadamente para comparar seu peso competitivo sem misturá-lo à visibilidade.',
    ],
  'Visibilidad de la marca': ['Brand visibility', 'Visibilidade da marca'],
  Componente: ['Component', 'Componente'],
  '02 / KPIs': ['02 / KPIs', '02 / KPIs'],
  'Cuatro métricas para saber': [
    'Four metrics to understand',
    'Quatro métricas para saber',
  ],
  'dónde estás.': ['where you stand.', 'onde você está.'],
  'Cada una se mide por motor y semana a semana, sobre los prompts de tu categoría. Son las mismas cuatro tarjetas que ves en el dashboard.':
    [
      "Each is measured by engine, week by week, using your category's prompts. These are the same four cards in your dashboard.",
      'Cada uma é medida por motor, semana a semana, com os prompts da sua categoria. São os mesmos quatro cartões do seu dashboard.',
    ],
  'Cuota de mercado': ['Market share', 'Participação de mercado'],
  Competencia: ['Competition', 'Concorrência'],
  Sentimiento: ['Sentiment', 'Sentimento'],
  '03 / Posicionamiento': ['03 / Positioning', '03 / Posicionamento'],
  'Aparecer no basta:': [
    'Being mentioned is just the start:',
    'Aparecer é só o começo:',
  ],
  'importa en qué lugar.': ['your position matters.', 'sua posição importa.'],
  'En cada respuesta medimos tres cosas: tu lugar en la lista, en qué parte del texto apareces y dónde cae tu primer enlace entre las fuentes.':
    [
      'We measure three things in each answer: your place in the list, where you appear in the text and the position of your first link among sources.',
      'Medimos três coisas em cada resposta: sua posição na lista, onde você aparece no texto e a posição do seu primeiro link entre as fontes.',
    ],
  Pregunta: ['Question', 'Pergunta'],
  '¿Qué empresas de mi categoría me recomiendas para una empresa mediana en Chile?':
    [
      'Which companies in my category would you recommend for a medium-sized business in Chile?',
      'Quais empresas da minha categoria você recomenda para uma empresa de médio porte no Chile?',
    ],
  'Fuente 1': ['Source 1', 'Fonte 1'],
  'Fuente 2': ['Source 2', 'Fonte 2'],
  '04 / Diagnóstico 4D': ['04 / 4D diagnosis', '04 / Diagnóstico 4D'],
  'El score dice cuánto.': [
    'The score tells you how much.',
    'O score diz quanto.',
  ],
  'El 4D, por qué.': ['The 4D tells you why.', 'O 4D, por quê.'],
  'El Diagnóstico 4D es un instrumento distinto del Score: suma 0 a 100 en cuatro dimensiones de 0 a 25 y muestra dónde están las brechas que frenan tu visibilidad.':
    [
      'The 4D diagnosis is separate from the score: four dimensions of 0–25 add up to 0–100 and reveal the gaps limiting your visibility.',
      'O diagnóstico 4D é separado do score: quatro dimensões de 0 a 25 somam de 0 a 100 e revelam as lacunas que limitam sua visibilidade.',
    ],
  Identidad: ['Identity', 'Identidade'],
  Reputación: ['Reputation', 'Reputação'],
  'Diagnóstico total': ['Overall diagnosis', 'Diagnóstico total'],
  'La dimensión más baja marca por dónde empieza el plan de acción.': [
    'The lowest dimension determines where the action plan starts.',
    'A dimensão mais baixa determina por onde começa o plano de ação.',
  ],
  'Datos de ejemplo': ['Sample data', 'Dados de exemplo'],
  'Cómo se calcula el diagnóstico': [
    'How the diagnosis is calculated',
    'Como o diagnóstico é calculado',
  ],
  '05 / Auditoría técnica · SEO': [
    '05 / Technical audit · SEO',
    '05 / Auditoria técnica · SEO',
  ],
  'Antes del contenido,': ['Before content,', 'Antes do conteúdo,'],
  'que la IA pueda leerte.': [
    'make sure AI can read you.',
    'garanta que a IA possa ler você.',
  ],
  'Revisamos tu sitio con los mismos criterios que usan los motores para rastrear y entender una página. Cada hallazgo se convierte en una acción del plan.':
    [
      'We review your site using the criteria engines use to crawl and understand pages. Each finding becomes an action in your plan.',
      'Revisamos seu site com os critérios que os motores usam para rastrear e entender páginas. Cada achado vira uma ação no plano.',
    ],
  Revisar: ['Review', 'Revisar'],
  Crítico: ['Critical', 'Crítico'],
  'Estados de ejemplo': ['Sample statuses', 'Status de exemplo'],
  'Cómo funciona el pipeline técnico': [
    'How the technical pipeline works',
    'Como funciona o pipeline técnico',
  ],
  '06 / Plan de acción': ['06 / Action plan', '06 / Plano de ação'],
  'Del hallazgo a la tarea,': ['From finding to task,', 'Do achado à tarefa,'],
  'en orden.': ['in priority order.', 'em ordem de prioridade.'],
  'Cada brecha del diagnóstico y de la auditoría se convierte en una acción concreta, con su impacto y su esfuerzo, ordenada para que lo primero sea lo que destraba lo demás.':
    [
      'Each diagnosis and audit gap becomes a concrete action with impact and effort estimates, prioritized to unlock what comes next.',
      'Cada lacuna do diagnóstico e da auditoria vira uma ação concreta com estimativas de impacto e esforço, priorizada para destravar o próximo passo.',
    ],
  'Impacto ·': ['Impact ·', 'Impacto ·'],
  'Esfuerzo ·': ['Effort ·', 'Esforço ·'],
  'Plan de ejemplo': ['Sample plan', 'Plano de exemplo'],
  '07 / Generación de contenido': [
    '07 / Content generation',
    '07 / Geração de conteúdo',
  ],
  'No solo te dice qué falta:': [
    "It identifies what's missing",
    'Identifica o que falta',
  ],
  'y lo escribe.': ['and writes it.', 'e escreve para você.'],
  'lo escribe.': ['and writes it.', 'e escreve para você.'],
  'A partir de las preguntas donde no apareces y de las brechas del diagnóstico, la plataforma genera las piezas que faltan, con los datos de tu marca y listas para publicar.':
    [
      "Using questions where you are missing and gaps from the diagnosis, the platform generates the content you need with your brand's data, ready to publish.",
      'Com base nas perguntas em que você não aparece e nas lacunas do diagnóstico, a plataforma gera o conteúdo necessário com os dados da sua marca, pronto para publicar.',
    ],
  'En el plan Enterprise, el equipo de Bison también las ejecuta y publica.': [
    "On Enterprise, Bison's team also produces and publishes them.",
    'No Enterprise, a equipe do Bison também produz e publica os conteúdos.',
  ],
  'Preguntas frecuentes': [
    'Frequently asked questions',
    'Perguntas frequentes',
  ],
  Artículos: ['Articles', 'Artigos'],
  'Guías paso a paso': ['Step-by-step guides', 'Guias passo a passo'],
  Glosario: ['Glossary', 'Glossário'],
  'Pregunta donde no apareces': [
    'A question where you are missing',
    'Uma pergunta em que você não aparece',
  ],
  'Pregunta frecuente sugerida': [
    'Suggested FAQ',
    'Pergunta frequente sugerida',
  ],
  Borrador: ['Draft', 'Rascunho'],
  'Lista para publicar': ['Ready to publish', 'Pronto para publicar'],
  'Tu equipo la revisa y la publica': [
    'Your team reviews and publishes it',
    'Sua equipe revisa e publica',
  ],
  '08 / Reportes': ['08 / Reports', '08 / Relatórios'],
  'Lo que cambió,': ['What changed,', 'O que mudou,'],
  'en lenguaje de negocio.': [
    'in business language.',
    'em linguagem de negócios.',
  ],
  'Cada semana recibes un reporte que se puede llevar a una reunión de gerencia, con cada cifra trazable hasta la respuesta original del motor.':
    [
      "Each week you get a report ready for a management meeting, with every figure traceable to the engine's original answer.",
      'Toda semana você recebe um relatório pronto para a reunião de gestão, com cada número rastreável até a resposta original do motor.',
    ],
  'Qué incluye': ["What's included", 'O que está incluído'],
  'Resumen ejecutivo': ['Executive summary', 'Resumo executivo'],
  'Evolución semanal': ['Weekly trends', 'Evolução semanal'],
  'Rendimiento por motor': ['Performance by engine', 'Desempenho por motor'],
  'Análisis competitivo': ['Competitive analysis', 'Análise competitiva'],
  'Alucinaciones detectadas': [
    'Detected hallucinations',
    'Alucinações detectadas',
  ],
  'Origen del conocimiento': ['Knowledge sources', 'Origem do conhecimento'],
  'Tráfico desde IA': ['Traffic from AI', 'Tráfego de IA'],
  'Hoja de ruta': ['Roadmap', 'Plano de ação'],
  'Reporte semanal': ['Weekly report', 'Relatório semanal'],
  'Semana 42': ['Week 42', 'Semana 42'],
  '09 / Agente e integraciones': [
    '09 / Agent and integrations',
    '09 / Agente e integrações',
  ],
  'Tus datos de visibilidad,': [
    'Your visibility data,',
    'Seus dados de visibilidade,',
  ],
  'donde ya trabajas.': ['where you already work.', 'onde você já trabalha.'],
  'Sin instalar nada en tu sitio. El agente y el servidor MCP leen las mismas métricas del dashboard; las integraciones las cruzan con tu tráfico.':
    [
      'No installation on your site. The agent and MCP server read your dashboard metrics; integrations connect them with your traffic.',
      'Sem instalar nada no seu site. O agente e o servidor MCP leem as métricas do dashboard; as integrações as cruzam com seu tráfego.',
    ],
  'Pregúntale a tus datos': ['Ask your data', 'Pergunte aos seus dados'],
  'Tus métricas en tu agente': [
    'Your metrics in your agent',
    'Suas métricas no seu agente',
  ],
  'Tráfico humano vs IA': ['Human vs AI traffic', 'Tráfego humano e de IA'],
  'La búsqueda clásica al lado': [
    'Traditional search alongside AI',
    'Busca tradicional ao lado da IA',
  ],
  'Detalle técnico del agente y el MCP': [
    'Technical details of the agent and MCP',
    'Detalhes técnicos do agente e do MCP',
  ],
  'Siguiente paso': ['Next step', 'Próximo passo'],
  'Mira tu propio dashboard.': [
    'See your own dashboard.',
    'Veja seu próprio dashboard.',
  ],
  'Con tu competencia al lado.': [
    'Alongside your competition.',
    'Com a concorrência ao lado.',
  ],
  'Ver planes': ['View plans', 'Ver planos'],
  'Ver metodología': ['View methodology', 'Ver metodologia'],
  'Solicitar diagnóstico': ['Request a diagnosis', 'Solicitar diagnóstico'],
  PLANES: ['PRICING', 'PLANOS'],
  Tres: ['Three', 'Três'],
  'Todos los motores generativos incluidos según el plan elegido y el nivel de personalización. Sin contratos de permanencia ni escalado por tamaño de empresa. Pago anual con 15% de descuento.':
    [
      'Generative engines included according to your plan and customization. No lock-in or pricing based on company size. Save 15% with annual billing.',
      'Motores generativos incluídos conforme seu plano e personalização. Sem fidelidade nem preços por tamanho da empresa. Desconto de 15% no pagamento anual.',
    ],
  'Calcular ROI estimado': ['Estimate ROI', 'Calcular ROI estimado'],
  'Descuento anual': ['Annual discount', 'Desconto anual'],
  'En planes base': ['On base plans', 'Nos planos base'],
  'Motores en Growth': ['Engines on Growth', 'Motores no Growth'],
  Personalizables: ['Customizable', 'Personalizáveis'],
  Soporte: ['Support', 'Suporte'],
  'Respuesta garantizada': ['Guaranteed response', 'Resposta garantida'],
  '01 / PLANES': ['01 / PLANS', '01 / PLANOS'],
  'Elige el formato': ['Choose the format', 'Escolha o formato'],
  'correcto para tu equipo.': [
    'that fits your team.',
    'ideal para sua equipe.',
  ],
  'Cada plan incluye todos los motores sin coste adicional. El precio no escala por tamaño de empresa.':
    [
      'Each plan includes its engines at no extra cost. Pricing does not scale with company size.',
      'Cada plano inclui seus motores sem custo adicional. O preço não varia com o tamanho da empresa.',
    ],
  '¿Gestionas varias marcas como agencia?': [
    'Managing multiple brands as an agency?',
    'Sua agência gerencia várias marcas?',
  ],
  'Ver el programa para agencias': [
    'Explore the agency program',
    'Conheça o programa para agências',
  ],
  'PLAN · 01': ['PLAN · 01', 'PLANO · 01'],
  'PLAN · 02': ['PLAN · 02', 'PLANO · 02'],
  'PLAN · 03 · RECOMENDADO': [
    'PLAN · 03 · RECOMMENDED',
    'PLANO · 03 · RECOMENDADO',
  ],
  PERSONALIZADO: ['CUSTOM', 'PERSONALIZADO'],
  'Para probar el monitoreo en un solo motor.': [
    'Try monitoring on a single engine.',
    'Experimente o monitoramento em um único motor.',
  ],
  '/ mes · 15 prompts/sem · 1 motor': [
    '/ month · 15 prompts/week · 1 engine',
    '/ mês · 15 prompts/semana · 1 motor',
  ],
  'Score AEO 0–100 semanal, por motor': [
    'Weekly AEO Score 0–100, per engine',
    'Score AEO 0–100 semanal, por motor',
  ],
  '200+ respuestas analizadas / mes': [
    '200+ answers analyzed / month',
    '200+ respostas analisadas / mês',
  ],
  '3 ejecuciones por motor / semana': [
    '3 runs per engine / week',
    '3 execuções por motor / semana',
  ],
  'Cobertura de motor generativo: ChatGPT': [
    'Generative engine coverage: ChatGPT',
    'Cobertura de motor generativo: ChatGPT',
  ],
  'Monitoreo de hasta 5 competidores': [
    'Monitor up to 5 competitors',
    'Monitore até 5 concorrentes',
  ],
  'Integración con Analytics y Search Console': [
    'Analytics and Search Console integration',
    'Integração com Analytics e Search Console',
  ],
  'Detalle de respuestas de IA por ejecución': [
    'AI answer details for each run',
    'Detalhes das respostas de IA por execução',
  ],
  'Empezar con Scout': ['Start with Scout', 'Começar com Scout'],
  'Para diagnosticar antes de comprometerte.': [
    'Diagnose before committing.',
    'Diagnostique antes de se comprometer.',
  ],
  '/ mes · 30 prompts/sem · 3 motores': [
    '/ month · 30 prompts/week · 3 engines',
    '/ mês · 30 prompts/semana · 3 motores',
  ],
  'Todo lo que incluye Scout': ['Everything in Scout', 'Tudo do Scout'],
  '1.600+ respuestas analizadas / mes': [
    '1,600+ answers analyzed / month',
    '1.600+ respostas analisadas / mês',
  ],
  '4–5 ejecuciones por motor / semana': [
    '4–5 runs per engine / week',
    '4–5 execuções por motor / semana',
  ],
  'Monitoreo de hasta 20 competidores': [
    'Monitor up to 20 competitors',
    'Monitore até 20 concorrentes',
  ],
  'Auditoría de schema.org y llms.txt': [
    'schema.org and llms.txt audit',
    'Auditoria de schema.org e llms.txt',
  ],
  'Playbook de acciones y recomendaciones': [
    'Action and recommendation playbook',
    'Playbook de ações e recomendações',
  ],
  'Reporte ejecutivo al CMO con prioridades': [
    'Prioritized executive report for your CMO',
    'Relatório executivo para o CMO com prioridades',
  ],
  'Empezar con Radar': ['Start with Radar', 'Começar com Radar'],
  'Para empresas que lideran la conversación en IA.': [
    'For businesses leading the AI conversation.',
    'Para empresas que lideram a conversa em IA.',
  ],
  '/ mes · 100 prompts/sem · 5 motores': [
    '/ month · 100 prompts/week · 5 engines',
    '/ mês · 100 prompts/semana · 5 motores',
  ],
  'Todo lo que incluye Radar': ['Everything in Radar', 'Tudo do Radar'],
  '6.700+ respuestas analizadas / mes': [
    '6,700+ answers analyzed / month',
    '6.700+ respostas analisadas / mês',
  ],
  'Generación de contenido AEO': [
    'AEO content generation',
    'Geração de conteúdo AEO',
  ],
  'Bison Agent integrado al dashboard': [
    'Bison Agent built into the dashboard',
    'Bison Agent integrado ao dashboard',
  ],
  'Servidor MCP — conecta tu propio agente': [
    'MCP server — connect your own agent',
    'Servidor MCP — conecte seu próprio agente',
  ],
  'Webhooks + alertas en tiempo real': [
    'Webhooks + real-time alerts',
    'Webhooks + alertas em tempo real',
  ],
  '1 sesión estratégica / mes': [
    '1 strategy session / month',
    '1 sessão estratégica / mês',
  ],
  'Empezar con Growth': ['Start with Growth', 'Começar com Growth'],
  'Operaciones que exigen escala y control total, con SLA, SSO e integración de datos.':
    [
      'Operations that need scale and full control, with SLA, SSO and data integration.',
      'Operações que exigem escala e controle total, com SLA, SSO e integração de dados.',
    ],
  'A medida': ['Custom pricing', 'Sob medida'],
  '/ retainer trimestral': ['/ quarterly retainer', '/ contrato trimestral'],
  'Todo lo que incluye Growth': ['Everything in Growth', 'Tudo do Growth'],
  'SLA dedicado · SSO · Account Manager': [
    'Dedicated SLA · SSO · Account Manager',
    'SLA dedicado · SSO · Gerente de conta',
  ],
  'Sincronización API y data warehouse': [
    'API and data warehouse sync',
    'Sincronização de API e data warehouse',
  ],
  'Benchmarks de LLMs personalizados': [
    'Custom LLM benchmarks',
    'Benchmarks personalizados de LLMs',
  ],
  'Onboarding estratégico multi-país': [
    'Multi-country strategic onboarding',
    'Onboarding estratégico em vários países',
  ],
  'Playbook de acciones e implementación': [
    'Action and implementation playbook',
    'Playbook de ações e implementação',
  ],
  'Motores de IA personalizados': [
    'Custom AI engines',
    'Motores de IA personalizados',
  ],
  'Hablar con ventas': ['Talk to sales', 'Fale com vendas'],
  '+ IVA': ['+ VAT', '+ IVA'],
  '02 / PERSONALIZA': ['02 / CUSTOMIZE', '02 / PERSONALIZE'],
  'Ajusta tu plan': ['Adjust your plan', 'Ajuste seu plano'],
  'según tu volumen.': ['to your volume.', 'ao seu volume.'],
  'Puedes sumar motores o prompts a tu plan. El precio varía según la combinación — a mayor volumen de uno, mayor el coste del otro.':
    [
      'Add engines or prompts to your plan. Pricing depends on the combination: more of one increases the cost of the other.',
      'Adicione motores ou prompts ao seu plano. O preço depende da combinação: mais volume de um aumenta o custo do outro.',
    ],
  incluido: ['included', 'incluído'],
  'Motores ↓': ['Engines ↓', 'Motores ↓'],
  'Prompts →': ['Prompts →', 'Prompts →'],
  'Más de 200 prompts o 5 motores →': [
    'More than 200 prompts or 5 engines →',
    'Mais de 200 prompts ou 5 motores →',
  ],
  'Tabla de personalización de precios. Contacta a ventas para combinar volúmenes superiores. Precios + IVA.':
    [
      'Pricing customization table. Contact sales for higher volumes. Prices exclude VAT.',
      'Tabela de personalização de preços. Fale com vendas para volumes maiores. Preços sem IVA.',
    ],
  '03 / COMPARACIÓN': ['03 / COMPARISON', '03 / COMPARAÇÃO'],
  'Todo lo que incluye': ['Everything included in', 'Tudo o que inclui'],
  'cada plan': ['each plan', 'cada plano'],
  'Cada feature está incluida, condicionada o no disponible. El plan Enterprise incluye todo más ejecución.':
    [
      'Features are included, conditional or unavailable. Enterprise includes everything plus execution.',
      'Os recursos estão incluídos, condicionados ou indisponíveis. O Enterprise inclui tudo, mais a execução.',
    ],
  Feature: ['Feature', 'Recurso'],
  Monitoreo: ['Monitoring', 'Monitoramento'],
  Ilimitados: ['Unlimited', 'Ilimitados'],
  Ilimitadas: ['Unlimited', 'Ilimitadas'],
  'Semanal/Diaria': ['Weekly/Daily', 'Semanal/Diária'],
  '✓ Lectura': ['✓ Read access', '✓ Leitura'],
  '✓ Ejecución': ['✓ Execution', '✓ Execução'],
  Servicio: ['Service', 'Serviço'],
  '1 / mes': ['1 / month', '1 / mês'],
  '1 / semana': ['1 / week', '1 / semana'],
  '✓ Sólo FAQs': ['✓ FAQs only', '✓ Apenas FAQs'],
  '✓ FAQs + Artículos': ['✓ FAQs + Articles', '✓ FAQs + Artigos'],
  '✓ Todo + publicación': ['✓ All + publishing', '✓ Tudo + publicação'],
  '✓ End-to-end': ['✓ End-to-end', '✓ Ponta a ponta'],
  Integraciones: ['Integrations', 'Integrações'],
  '✓ Full': ['✓ Full', '✓ Completo'],
  Cumplimiento: ['Compliance', 'Conformidade'],
  'Las respuestas analizadas incluyen 3–5 ejecuciones por prompt por motor para reducir varianza estadística. Precios + IVA.':
    [
      'Analyzed answers include 3–5 runs per prompt per engine to reduce statistical variance. Prices exclude VAT.',
      'As respostas analisadas incluem 3–5 execuções por prompt por motor para reduzir a variância estatística. Preços sem IVA.',
    ],
  '04 / COBERTURA': ['04 / COVERAGE', '04 / COBERTURA'],
  'Qué motor cubre': ['Engines covered by', 'Quais motores inclui'],
  'Cada motor generativo tiene sus propias fuentes de cita y criterios de ranking. Más motores monitoreados equivale a una imagen más completa de tu visibilidad real en IA.':
    [
      'Each engine has its own citation sources and ranking criteria. Monitoring more engines gives you a more complete picture of your AI visibility.',
      'Cada motor tem suas próprias fontes de citação e critérios de ranking. Monitorar mais motores oferece uma visão mais completa da sua visibilidade em IA.',
    ],
  Motor: ['Engine', 'Motor'],
  'Prompts únicos': ['Unique prompts', 'Prompts únicos'],
  'Plan Growth: ~6.700 respuestas analizadas/mes. Motores adicionales disponibles en Enterprise a medida.':
    [
      'Growth: ~6,700 answers analyzed/month. Additional engines available with custom Enterprise plans.',
      'Growth: ~6.700 respostas analisadas/mês. Motores adicionais disponíveis no Enterprise sob medida.',
    ],
  '05 / ROI ESTIMADO': ['05 / ESTIMATED ROI', '05 / ROI ESTIMADO'],
  'Lo que cuesta': ['The cost of', 'O custo de'],
  'no estar': ['being absent', 'ficar de fora'],
  'en los LLMs.': ['from LLMs.', 'dos LLMs.'],
  'Ajusta los inputs y verás cuántas oportunidades te puede estar costando hoy la invisibilidad AEO.':
    [
      'Adjust the inputs to estimate opportunities you may be losing through AEO invisibility.',
      'Ajuste os dados para estimar as oportunidades que você pode estar perdendo pela invisibilidade em AEO.',
    ],
  'Búsquedas mensuales sobre tu categoría (LATAM, en español)': [
    'Monthly category searches (Latin America, Spanish)',
    'Buscas mensais da sua categoria (América Latina, em espanhol)',
  ],
  '% de búsquedas que ya pasan por LLMs en tu sector': [
    '% of searches already using LLMs in your sector',
    '% de buscas que já usam LLMs no seu setor',
  ],
  'Valor promedio del lead': ['Average lead value', 'Valor médio do lead'],
  'VOLUMEN MENSUAL EN RIESGO': [
    'MONTHLY VOLUME AT RISK',
    'VOLUME MENSAL EM RISCO',
  ],
  'leads/mes': ['leads/month', 'leads/mês'],
  'Asumiendo conversión típica del 22% del share-of-voice perdido': [
    'Assuming a typical 22% conversion of lost share of voice',
    'Considerando conversão típica de 22% do share of voice perdido',
  ],
  'VALOR EQUIVALENTE': ['EQUIVALENT VALUE', 'VALOR EQUIVALENTE'],
  'Costo anual estimado de la invisibilidad AEO': [
    'Estimated annual cost of AEO invisibility',
    'Custo anual estimado da invisibilidade AEO',
  ],
  'COMPARADO CON': ['COMPARED WITH', 'COMPARADO COM'],
  'Plan Growth ·': ['Growth plan ·', 'Plano Growth ·'],
  METODOLOGÍA: ['METHODOLOGY', 'METODOLOGIA'],
  'SUPUESTO CLAVE': ['KEY ASSUMPTION', 'PREMISSA PRINCIPAL'],
  'RANGO REAL': ['ACTUAL RANGE', 'FAIXA REAL'],
  '06 / VENTAJA LATAM': [
    '06 / LATIN AMERICAN ADVANTAGE',
    '06 / VANTAGEM NA AMÉRICA LATINA',
  ],
  'Hablamos el idioma': ['We speak the language', 'Falamos o idioma'],
  'de tus clientes.': ['of your customers.', 'dos seus clientes.'],
  'Desde el idioma en que te buscan hasta cómo la IA te recomienda: conocemos tu mercado y lo medimos motor por motor, cada semana.':
    [
      'From the language people use to find you to how AI recommends you: we know your market and measure it engine by engine, every week.',
      'Do idioma usado para encontrar você até como a IA recomenda sua marca: conhecemos seu mercado e o medimos motor por motor, toda semana.',
    ],
  'Entrenado en el español de la región': [
    'Trained on Latin American Spanish',
    'Treinado no espanhol da região',
  ],
  'Extraemos las marcas de cada respuesta con un modelo de lenguaje y reglas propias pensadas para el español de LatAm: agrupamos variantes del mismo nombre y separamos filiales con marca propia, midiendo en la región cada semana.':
    [
      'We extract the brands from each answer with a language model and our own rules built for Latin American Spanish: we group variants of the same name and separate subsidiaries with their own brand, measuring in the region every week.',
      'Extraímos as marcas de cada resposta com um modelo de linguagem e regras próprias pensadas para o espanhol da América Latina: agrupamos variantes do mesmo nome e separamos filiais com marca própria, medindo na região toda semana.',
    ],
  'Hecha para tu mercado': ['Built for your market', 'Feita para seu mercado'],
  'Priorizamos los motores y los prompts que de verdad importan en tu país. La cobertura se arma por mercado —Chile, México, Colombia, Argentina, Perú y Uruguay— según dónde compite tu empresa.':
    [
      'We prioritize the engines and prompts that matter in your country. Coverage is built by market — Chile, Mexico, Colombia, Argentina, Peru and Uruguay — based on where you compete.',
      'Priorizamos os motores e prompts relevantes no seu país. A cobertura é montada por mercado — Chile, México, Colômbia, Argentina, Peru e Uruguai — conforme onde sua empresa compete.',
    ],
  'Del diagnóstico al contenido': [
    'From diagnosis to content',
    'Do diagnóstico ao conteúdo',
  ],
  'Bison cubre el ciclo completo: diagnostica las brechas, genera las piezas de contenido para cerrarlas y posiciona tu marca en los motores. De la medición a la acción, en una sola plataforma.':
    [
      'Bison covers the full cycle: diagnose gaps, generate content to close them and position your brand in engines. From measurement to action in one platform.',
      'O Bison cobre o ciclo completo: diagnostica lacunas, gera conteúdo para fechá-las e posiciona sua marca nos motores. Da medição à ação em uma plataforma.',
    ],
  'Citas, share-of-voice y sentimiento': [
    'Citations, share of voice and sentiment',
    'Citações, share of voice e sentimento',
  ],
  'Reportamos citas, share-of-voice, posición y sentimiento en cada motor: sabes si la IA te recomienda, con qué peso y con qué tono. Métricas trazables hasta la respuesta original del motor.':
    [
      'We report citations, share of voice, position and sentiment in each engine: whether AI recommends you, with what weight and tone. Every metric is traceable to the original answer.',
      'Informamos citações, share of voice, posição e sentimento em cada motor: se a IA recomenda você, com qual peso e tom. Cada métrica é rastreável até a resposta original.',
    ],
  '07 / Dudas habituales': [
    '07 / Frequently asked questions',
    '07 / Perguntas frequentes',
  ],
  'Preguntas sobre': ['Questions about', 'Perguntas sobre'],
  'precios y contratos.': ['pricing and contracts.', 'preços e contratos.'],
  'Si tu duda no está aquí, escríbenos. Lo que firmas es lo que pagas; no movemos precios después.':
    [
      'If your question is missing, write to us. You pay what you sign for; prices stay as agreed.',
      'Se sua pergunta não está aqui, escreva para nós. Você paga o que assina; os preços continuam como combinado.',
    ],
  Empezar: ['Get started', 'Começar'],
  'El plan correcto empieza': ['The right plan starts', 'O plano certo começa'],
  'con un diagnóstico.': ['with a diagnosis.', 'com um diagnóstico.'],
  RANKINGS: ['RANKINGS', 'RANKINGS'],
  'Quién lidera': ['Who leads', 'Quem lidera'],
  'cada industria en ChatGPT, Claude y Gemini': [
    'each industry in ChatGPT, Claude and Gemini',
    'cada setor no ChatGPT, Claude e Gemini',
  ],
  // Hub /rankings y hubs por país (spec 021): títulos, análisis y FAQ.
  'Latinoamérica': ['Latin America', 'América Latina'],
  'Quién lidera cada industria en ChatGPT, Claude y Gemini.': [
    'Who leads each industry in ChatGPT, Claude and Gemini.',
    'Quem lidera cada setor no ChatGPT, Claude e Gemini.',
  ],
  'Ranking de marcas en IA': [
    'AI brand ranking',
    'Ranking de marcas na IA',
  ],
  'en Latinoamérica: quién lidera cada industria en ChatGPT, Claude y Gemini': [
    'in Latin America: who leads each industry in ChatGPT, Claude and Gemini',
    'na América Latina: quem lidera cada setor no ChatGPT, Claude e Gemini',
  ],
  'El ranking de visibilidad de marcas en inteligencia artificial de Latinoamérica: {countries} países y {rankings} industrias medidas con las mismas preguntas de compra en ChatGPT, Claude y Gemini, sin nombrar marcas. Publicado desde el 11 de octubre de 2026 y en ocho países desde el 2 de noviembre de 2026; cada ranking publica su muestra y sus límites.': [
    'The Latin America AI brand visibility ranking: {countries} countries and {rankings} industries measured with the same purchase questions in ChatGPT, Claude and Gemini, without naming brands. Published since 11 October 2026 and in eight countries since 2 November 2026; each ranking publishes its sample and limitations.',
    'O ranking de visibilidade de marcas na inteligência artificial da América Latina: {countries} países e {rankings} setores medidos com as mesmas perguntas de compra no ChatGPT, Claude e Gemini, sem citar marcas. Publicado desde 11 de outubro de 2026 e em oito países desde 2 de novembro de 2026; cada ranking publica sua amostra e seus limites.',
  ],
  'Ranking de marcas en IA en {country}': [
    'AI brand ranking in {country}',
    'Ranking de marcas na IA · {country}',
  ],
  ': quién lidera cada industria en ChatGPT, Claude y Gemini': [
    ': who leads each industry in ChatGPT, Claude and Gemini',
    ': quem lidera cada setor no ChatGPT, Claude e Gemini',
  ],
  'Análisis': [
    'Analysis',
    'Análise',
  ],
  'Ocho países,': [
    'Eight countries,',
    'Oito países,',
  ],
  'una medición.': [
    'one measurement.',
    'uma medição.',
  ],
  'Los rankings de los ocho países leídos juntos: cuánto nombra la IA a las marcas en cada país y cómo cambia el líder según el motor.': [
    'The rankings of the eight countries read together: how often AI names brands in each country and how the leader changes by engine.',
    'Os rankings dos oito países lidos juntos: quanto a IA cita as marcas em cada país e como o líder muda conforme o motor.',
  ],
  'Análisis de 565 rankings y 27.576 respuestas de ChatGPT, Claude y Gemini, noviembre de 2026.': [
    'Analysis of 565 rankings and 27,576 answers from ChatGPT, Claude and Gemini, November 2026.',
    'Análise de 565 rankings e 27.576 respostas do ChatGPT, Claude e Gemini, novembro de 2026.',
  ],
  'Leer el análisis de Latinoamérica': [
    'Read the Latin America analysis',
    'Ler a análise da América Latina',
  ],
  'Preguntas': [
    'Questions',
    'Perguntas',
  ],
  'Qué mide': [
    'What this',
    'O que este',
  ],
  'este ranking.': [
    'ranking measures.',
    'ranking mede.',
  ],
  '¿Cuál es el primer ranking de IA de marcas en Latinoamérica?': [
    'What is the first AI brand ranking in Latin America?',
    'Qual é o primeiro ranking de marcas na IA da América Latina?',
  ],
  '¿Qué es un ranking de marcas en IA?': [
    'What is an AI brand ranking?',
    'O que é um ranking de marcas na IA?',
  ],
  '¿Qué países e industrias cubre el ranking?': [
    'Which countries and industries does the ranking cover?',
    'Quais países e setores o ranking cobre?',
  ],
  '¿Cómo se mide la visibilidad de una marca en la IA?': [
    'How is a brand\'s visibility in AI measured?',
    'Como se mede a visibilidade de uma marca na IA?',
  ],
  '¿Cada cuánto se actualizan los rankings?': [
    'How often are the rankings updated?',
    'Com que frequência os rankings são atualizados?',
  ],
  'Bison Agents publicó su primer ranking de marcas en IA el 11 de octubre de 2026, con 27 industrias de Chile medidas el 23 y 24 de septiembre. El 21 de octubre sumó las industrias regionales de Chile; el 27 de octubre, su ranking de sustentabilidad en IA; y el 2 de noviembre de 2026, los rankings de Argentina, Brasil, Colombia, Ecuador, México, Perú y Uruguay. Hoy cubre ocho países (Argentina, Brasil, Chile, Colombia, Ecuador, México, Perú y Uruguay), más de 580 rankings por industria y tres motores (ChatGPT, Claude y Gemini), medidos con el mismo método: las mismas preguntas de compra, sin nombrar marcas.': [
    'Bison Agents published its first AI brand ranking on 11 October 2026, with 27 industries in Chile measured on 23 and 24 September. On 21 October it added Chile\'s regional industries; on 27 October, its AI sustainability ranking; and on 2 November 2026, the rankings for Argentina, Brazil, Colombia, Ecuador, Mexico, Peru and Uruguay. It now covers eight countries (Argentina, Brazil, Chile, Colombia, Ecuador, Mexico, Peru and Uruguay), more than 580 rankings by industry and three engines (ChatGPT, Claude and Gemini), measured with the same method: the same purchase questions, without naming brands.',
    'A Bison Agents publicou seu primeiro ranking de marcas na IA em 11 de outubro de 2026, com 27 setores do Chile medidos em 23 e 24 de setembro. Em 21 de outubro somou os setores regionais do Chile; em 27 de outubro, seu ranking de sustentabilidade na IA; e em 2 de novembro de 2026, os rankings de Argentina, Brasil, Colômbia, Equador, México, Peru e Uruguai. Hoje cobre oito países (Argentina, Brasil, Chile, Colômbia, Equador, México, Peru e Uruguai), mais de 580 rankings por setor e três motores (ChatGPT, Claude e Gemini), medidos com o mesmo método: as mesmas perguntas de compra, sem citar marcas.',
  ],
  'Es una medición de qué marcas nombran los asistentes de inteligencia artificial cuando una persona pregunta qué comprar, dónde ir o a quién contratar, sin mencionar ninguna marca. No es un ranking de herramientas de IA ni de qué asistente usa más la gente: mide en qué porcentaje de las respuestas de ChatGPT, Claude y Gemini aparece cada marca en su industria y su país.': [
    'It measures which brands AI assistants name when someone asks what to buy, where to go or whom to hire, without mentioning any brand. It is not a ranking of AI tools or of which assistant people use most: it measures the share of ChatGPT, Claude and Gemini answers in which each brand appears, within its industry and country.',
    'É uma medição de quais marcas os assistentes de inteligência artificial citam quando alguém pergunta o que comprar, aonde ir ou quem contratar, sem mencionar nenhuma marca. Não é um ranking de ferramentas de IA nem de qual assistente as pessoas mais usam: mede em que porcentagem das respostas do ChatGPT, Claude e Gemini cada marca aparece, no seu setor e no seu país.',
  ],
  'Ocho países de Latinoamérica: Argentina, Brasil, Chile, Colombia, Ecuador, México, Perú y Uruguay. En cada país se miden más de 60 industrias: bancos, seguros, telecomunicaciones, supermercados, farmacias, universidades, aerolíneas, autos, software y más. Chile suma rankings de industrias regionales y un ranking de sustentabilidad. Las preguntas de Brasil se hacen en portugués; las del resto, en el español de cada país.': [
    'Eight Latin American countries: Argentina, Brazil, Chile, Colombia, Ecuador, Mexico, Peru and Uruguay. More than 60 industries are measured in each country: banks, insurance, telecommunications, supermarkets, pharmacies, universities, airlines, cars, software and more. Chile adds regional industry rankings and a sustainability ranking. Questions for Brazil are asked in Portuguese; the rest, in each country\'s Spanish.',
    'Oito países da América Latina: Argentina, Brasil, Chile, Colômbia, Equador, México, Peru e Uruguai. Em cada país são medidos mais de 60 setores: bancos, seguros, telecomunicações, supermercados, farmácias, universidades, companhias aéreas, carros, software e mais. O Chile soma rankings de setores regionais e um ranking de sustentabilidade. As perguntas do Brasil são feitas em português; as dos demais, no espanhol de cada país.',
  ],
  'Para cada industria escribimos las preguntas que haría un cliente al comprar o comparar, sin nombrar marcas, y se las hacemos con las mismas palabras a ChatGPT, Claude y Gemini. La visibilidad de una marca es el porcentaje de esas respuestas en que aparece nombrada. Cada ranking publica su muestra, las preguntas, la visibilidad por motor, las fuentes citadas y sus límites. Mide cuánto nombra la IA a la marca, no su calidad ni sus ventas.': [
    'For each industry we write the questions a customer would ask when buying or comparing, without naming brands, and ask them with the same wording to ChatGPT, Claude and Gemini. A brand\'s visibility is the percentage of those answers in which it is named. Each ranking publishes its sample, the questions, visibility by engine, the sources cited and its limitations. It measures how often AI names the brand, not its quality or its sales.',
    'Para cada setor escrevemos as perguntas que um cliente faria ao comprar ou comparar, sem citar marcas, e as fazemos com as mesmas palavras ao ChatGPT, Claude e Gemini. A visibilidade de uma marca é a porcentagem dessas respostas em que ela é citada. Cada ranking publica sua amostra, as perguntas, a visibilidade por motor, as fontes citadas e seus limites. Mede quanto a IA cita a marca, não sua qualidade nem suas vendas.',
  ],
  'Los rankings nacionales se miden cada mes y el ranking de sustentabilidad, cada tres meses. Cada ranking indica la fecha de su captura. Una respuesta de IA cambia con el modelo y con el día, así que cada medición es una foto de esa semana.': [
    'National rankings are measured every month and the sustainability ranking every three months. Each ranking states its capture date. An AI answer changes with the model and the day, so each measurement is a snapshot of that week.',
    'Os rankings nacionais são medidos todo mês e o ranking de sustentabilidade, a cada três meses. Cada ranking indica a data da sua captura. Uma resposta de IA muda com o modelo e com o dia, então cada medição é uma foto daquela semana.',
  ],
  'Medimos con qué frecuencia aparece cada marca en las respuestas de los asistentes de IA ante las mismas preguntas de compra. Cada ranking publica su muestra y sus límites.':
    [
      "We measure how often each brand appears in AI assistants' answers to the same purchase questions. Each ranking publishes its sample and limitations.",
      'Medimos com que frequência cada marca aparece nas respostas de assistentes de IA às mesmas perguntas de compra. Cada ranking publica sua amostra e seus limites.',
    ],
  'Industrias medidas': ['Industries measured', 'Setores medidos'],
  Marcas: ['Brands', 'Marcas'],
  'Entre todas las industrias': [
    'Across all industries',
    'Em todos os setores',
  ],
  Capturas: ['Captures', 'Capturas'],
  'ChatGPT, Claude y Gemini': [
    'ChatGPT, Claude and Gemini',
    'ChatGPT, Claude e Gemini',
  ],
  'Última medición': ['Latest measurement', 'Última medição'],
  'Medición mensual': ['Monthly measurement', 'Medição mensal'],
  Industrias: ['Industries', 'Setores'],
  'Elige una': ['Choose an', 'Escolha um'],
  'industria.': ['industry.', 'setor.'],
  'El índice de visibilidad es relativo a cada industria: no describe ventas ni la calidad de las marcas.':
    [
      'The visibility index is relative to each industry: it does not describe sales or brand quality.',
      'O índice de visibilidade é relativo a cada setor: ele não descreve vendas nem a qualidade das marcas.',
    ],
  Regiones: ['Regions', 'Regiões'],
  'regionales.': ['regional.', 'regionais.'],
  'Agrupadas por macrozona, de norte a sur.': [
    'Grouped by region, from north to south.',
    'Agrupados por macrorregião, de norte a sul.',
  ],
  'Ver las': ['Explore the', 'Ver os'],
  'industrias regionales': ['regional industries', 'setores regionais'],
  Sustentabilidad: ['Sustainability', 'Sustentabilidade'],
  'Quién es referente': ['Who sets the standard', 'Quem é referência'],
  'para la IA.': ['for AI.', 'para a IA.'],
  'Clima, agua, ecosistemas, comunidades, personas y gobernanza.': [
    'Climate, water, ecosystems, communities, people and governance.',
    'Clima, água, ecossistemas, comunidades, pessoas e governança.',
  ],
  'Ver el ranking de sustentabilidad': [
    'Explore the sustainability ranking',
    'Ver o ranking de sustentabilidade',
  ],
  '{count} industrias propias de una región de {country}: turismo, enoturismo, minería, acuicultura y productos del sur. La mayoría de sus preguntas nombran la región.':
    [
      '{count} regional industries in {country}: tourism, wine tourism, mining, aquaculture and southern products. Most questions name the region.',
      '{count} setores regionais em {country}: turismo, enoturismo, mineração, aquicultura e produtos do sul. A maioria das perguntas cita a região.',
    ],
  'A quién presenta la IA como referente en sustentabilidad en {count} rankings de {country}: minería, forestal, salmonicultura, energía, banca, retail y más. Medición trimestral.':
    [
      'Who AI presents as a sustainability leader across {count} rankings in {country}: mining, forestry, salmon farming, energy, banking, retail and more. Quarterly measurement.',
      'Quem a IA apresenta como referência em sustentabilidade em {count} rankings de {country}: mineração, setor florestal, salmonicultura, energia, bancos, varejo e mais. Medição trimestral.',
    ],
  Lidera: ['Leading brand', 'Líder'],
  'marcas ·': ['brands ·', 'marcas ·'],
  'consultas ·': ['queries ·', 'consultas ·'],
  capturas: ['captures', 'capturas'],
  'Ver ranking': ['View ranking', 'Ver ranking'],
  Consultas: ['Queries', 'Consultas'],
  'Con qué frecuencia ChatGPT, Claude y Gemini presentan a cada marca como referente cuando se les pregunta por la sustentabilidad de':
    [
      'How often ChatGPT, Claude and Gemini present each brand as a leader when asked about sustainability in',
      'Com que frequência ChatGPT, Claude e Gemini apresentam cada marca como referência quando perguntados sobre sustentabilidade em',
    ],
  'Con qué frecuencia aparece cada marca cuando los compradores le preguntan a ChatGPT, Claude y Gemini por':
    [
      'How often each brand appears when buyers ask ChatGPT, Claude and Gemini about',
      'Com que frequência cada marca aparece quando compradores perguntam ao ChatGPT, Claude e Gemini sobre',
    ],
  'Lidera la industria ·': ['Industry leader ·', 'Líder do setor ·'],
  'Lidera desde': ['Leading since', 'Líder desde'],
  'Ir al ranking': ['Go to ranking', 'Ir para o ranking'],
  Nueva: ['New', 'Nova'],
  '01 / Ranking': ['01 / Ranking', '01 / Ranking'],
  'Quién aparece': ['Who appears', 'Quem aparece'],
  'más.': ['most often.', 'mais.'],
  'Marcas ordenadas por visibilidad en las respuestas de IA': [
    'Brands ranked by visibility in AI answers',
    'Marcas ordenadas por visibilidade nas respostas de IA',
  ],
  Marca: ['Brand', 'Marca'],
  Visibilidad: ['Visibility', 'Visibilidade'],
  Menciones: ['Mentions', 'Menções'],
  Prominencia: ['Prominence', 'Proeminência'],
  Citabilidad: ['Citability', 'Citabilidade'],
  'Tu marca': ['Your brand', 'Sua marca'],
  '¿Dónde aparece tu marca': [
    'Where does your brand appear',
    'Onde sua marca aparece',
  ],
  'Ver todos los rankings': ['View all rankings', 'Ver todos os rankings'],
  'Volver a rankings': ['Back to rankings', 'Voltar aos rankings'],
  'PREFERENCIAS DE COOKIES': ['COOKIE PREFERENCES', 'PREFERÊNCIAS DE COOKIES'],
  'Preguntas frecuentes, cada semana.': [
    'Frequently asked questions, every week.',
    'Perguntas frequentes, toda semana.',
  ],
  tu: ['your', 'sua'],
  'Mi CMO pregunta por qué bajamos en ChatGPT este mes.': [
    'My CMO asks why we dropped in ChatGPT this month.',
    'Meu CMO pergunta por que caímos no ChatGPT este mês.',
  ],
  'Dame los 3 motivos en orden de impacto.': [
    'Give me the 3 reasons in order of impact.',
    'Dê os 3 motivos em ordem de impacto.',
  ],
  'Tres causas, mayor a menor impacto:': [
    'Three causes, from highest to lowest impact:',
    'Três causas, do maior para o menor impacto:',
  ],
  'Tu competidor #2 publicó un caso de uso el 4 de mayo que el motor está priorizando para 18 de tus prompts':
    [
      'Your #2 competitor published a use case on May 4 that the engine now prioritizes for 18 of your prompts',
      'Seu concorrente nº 2 publicou um caso de uso em 4 de maio que o motor prioriza para 18 dos seus prompts',
    ],
  'apunta a /docs/v1 que ya no existe (error 404).': [
    'points to /docs/v1, which no longer exists (404 error).',
    'aponta para /docs/v1, que não existe mais (erro 404).',
  ],
  'Schema en /pricing falla intermitentemente desde el último deploy.': [
    'Schema on /pricing has failed intermittently since the last deployment.',
    'O schema em /pricing falha de forma intermitente desde o último deploy.',
  ],
  '¿Genero el brief para tu equipo o lo corrijo directo?': [
    'Should I write a brief for your team or fix it directly?',
    'Devo gerar o briefing para sua equipe ou corrigir diretamente?',
  ],
  'OPERÓ · 6 ACCIONES · 3.4s': [
    'COMPLETED · 6 ACTIONS · 3.4s',
    'CONCLUÍDO · 6 AÇÕES · 3,4s',
  ],
  'CLAUDE OPUS 4.8 · TRAZABLE': [
    'CLAUDE OPUS 4.8 · TRACEABLE',
    'CLAUDE OPUS 4.8 · RASTREÁVEL',
  ],
  Connected: ['Connected', 'Conectado'],
  '"plataformas AEO" → Bison Agents en respuesta principal': [
    '"AEO platforms" → Bison Agents in the main answer',
    '"plataformas AEO" → Bison Agents na resposta principal',
  ],
  '"medir IA generativa" → mención + link a manual de Bison': [
    '"measure generative AI" → mention + link to Bison\'s guide',
    '"medir IA generativa" → menção + link para o guia do Bison',
  ],
  '"AEO LATAM" → Bison Agents en lista comparativa': [
    '"AEO LATAM" → Bison Agents in a comparison list',
    '"AEO LATAM" → Bison Agents em lista comparativa',
  ],
  '"answer engine optimization español" → Bison como ejemplo': [
    '"answer engine optimization Spanish" → Bison as an example',
    '"answer engine optimization espanhol" → Bison como exemplo',
  ],
  'Identidad · Schema.org incompleto: faltan Organization y sameAs a perfiles oficiales':
    [
      'Identity · Incomplete Schema.org: missing Organization and sameAs links to official profiles',
      'Identidade · Schema.org incompleto: faltam Organization e sameAs para perfis oficiais',
    ],
  'Identidad · Nombre de marca inconsistente entre el sitio y los directorios':
    [
      'Identity · Brand name differs between the website and directories',
      'Identidade · Nome da marca inconsistente entre o site e os diretórios',
    ],
  'Reputación · Perfil de reseñas sin reclamar y sin respuestas': [
    'Reputation · Unclaimed review profile with no responses',
    'Reputação · Perfil de avaliações não reivindicado e sem respostas',
  ],
  'Editorial · Sin cobertura en medios de autoridad de la categoría': [
    'Editorial · No coverage in authoritative industry media',
    'Editorial · Sem cobertura em veículos de referência do setor',
  ],
  'CLIENTE · DEMO · MAYO 2026': [
    'CUSTOMER · DEMO · MAY 2026',
    'CLIENTE · DEMO · MAIO DE 2026',
  ],
  Cobertura: ['Coverage', 'Cobertura'],
  'Tráfico IA': ['AI traffic', 'Tráfego de IA'],
  Diagnóstico: ['Diagnosis', 'Diagnóstico'],
  Mejoras: ['Improvements', 'Melhorias'],
  Competidores: ['Competitors', 'Concorrentes'],
  Semanal: ['Weekly', 'Semanal'],
  Mensual: ['Monthly', 'Mensal'],
  'Overview · semana 15': ['Overview · week 15', 'Visão geral · semana 15'],
  'Última lectura · hace 14 min': [
    'Last reading · 14 min ago',
    'Última leitura · há 14 min',
  ],
  'Últimas citas detectadas': [
    'Latest detected citations',
    'Últimas citações detectadas',
  ],
  'Brechas críticas pendientes': [
    'Critical gaps pending',
    'Lacunas críticas pendentes',
  ],
  'Schema.org incompleto': ['Incomplete Schema.org', 'Schema.org incompleto'],
  'Falta SoftwareApplication + AggregateRating. Los LLMs no resuelven entidad.':
    [
      'Missing SoftwareApplication + AggregateRating. LLMs cannot identify the entity.',
      'Faltam SoftwareApplication + AggregateRating. Os LLMs não identificam a entidade.',
    ],
  'Identidad · Crítico': ['Identity · Critical', 'Identidade · Crítico'],
  'Sin llms.txt publicado': ['No published llms.txt', 'Sem llms.txt publicado'],
  'Standard emergente. Hoy lo leen Perplexity y Anthropic. Tiempo estimado: 2 h.':
    [
      'Emerging standard read by Perplexity and Anthropic. Estimated time: 2 h.',
      'Padrão emergente lido por Perplexity e Anthropic. Tempo estimado: 2 h.',
    ],
  'Identidad · Alto': ['Identity · High', 'Identidade · Alto'],
  'Trustpilot sin perfil reclamado': [
    'Unclaimed Trustpilot profile',
    'Perfil do Trustpilot não reivindicado',
  ],
  '11 reseñas orgánicas, ninguna respondida. Quick win con impacto cita en 3 motores.':
    [
      '11 organic reviews, none answered. A quick win affecting citations in 3 engines.',
      '11 avaliações orgânicas, nenhuma respondida. Ganho rápido com impacto nas citações em 3 motores.',
    ],
  'Reputación · Medio': ['Reputation · Medium', 'Reputação · Médio'],
  'Wikipedia ES sin entrada': [
    'No Spanish Wikipedia entry',
    'Sem página na Wikipédia em espanhol',
  ],
  'Bloquea citas en Gemini y Google AIO. Requiere editor con >100 ediciones previas.':
    [
      'Blocks citations in Gemini and Google AIO. Requires an editor with >100 prior edits.',
      'Bloqueia citações no Gemini e no Google AIO. Exige editor com >100 edições anteriores.',
    ],
  'Editorial · Medio': ['Editorial · Medium', 'Editorial · Médio'],
  'Sin presencia en subreddits sectoriales': [
    'No presence in industry subreddits',
    'Sem presença em subreddits do setor',
  ],
  'r/marketing · r/SaaS · r/spanish. Conversación pública es input de muestreo.':
    [
      'r/marketing · r/SaaS · r/spanish. Public conversation informs sampling.',
      'r/marketing · r/SaaS · r/spanish. Conversas públicas alimentam a amostragem.',
    ],
  'Social · Bajo': ['Social · Low', 'Social · Baixo'],
  'Schema.org completo': ['Complete Schema.org', 'Schema.org completo'],
  '8 h · impacto +14 pts': ['8 h · impact +14 pts', '8 h · impacto +14 pts'],
  'Publicar llms.txt': ['Publish llms.txt', 'Publicar llms.txt'],
  '2 h · impacto +6 pts': ['2 h · impact +6 pts', '2 h · impacto +6 pts'],
  'Plan de reseñas G2': ['G2 review plan', 'Plano de avaliações no G2'],
  '24 h · impacto +11 pts': ['24 h · impact +11 pts', '24 h · impacto +11 pts'],
  'Wiki ES estructurada': [
    'Structured Spanish wiki',
    'Wiki em espanhol estruturada',
  ],
  '40 h · impacto +9 pts': ['40 h · impact +9 pts', '40 h · impacto +9 pts'],
  'Hub técnico AEO': ['AEO technical hub', 'Hub técnico AEO'],
  'LinkedIn CEO firmado': [
    'Signed CEO LinkedIn post',
    'Publicação assinada pelo CEO no LinkedIn',
  ],
  '2 posts/sem · +7 pts': ['2 posts/week · +7 pts', '2 posts/semana · +7 pts'],
  '+86 vs prev': ['+86 vs previous', '+86 ante o anterior'],
  Editorial: ['Editorial', 'Editorial'],
  Social: ['Social', 'Social'],
  'En cuántas respuestas apareces cuando alguien pregunta por tu categoría.': [
    'How many answers mention you when someone asks about your category.',
    'Em quantas respostas você aparece quando alguém pergunta sobre sua categoria.',
  ],
  'Cuántas de esas respuestas enlazan tu sitio como fuente.': [
    'How many of those answers link to your website as a source.',
    'Quantas dessas respostas incluem um link para seu site como fonte.',
  ],
  Posición: ['Position', 'Posição'],
  'Qué tan arriba apareces dentro de la respuesta: no es lo mismo ser el primero que el último de la lista.':
    [
      'How high you appear in the answer: first and last in the list are not the same.',
      'Em que posição você aparece na resposta: ser o primeiro é diferente de ser o último da lista.',
    ],
  'Si el motor habla bien, neutro o mal de tu marca cuando te menciona.': [
    'Whether the engine speaks positively, neutrally or negatively about your brand.',
    'Se o motor fala de forma positiva, neutra ou negativa sobre sua marca.',
  ],
  'Frecuencia de aparición': ['Mention frequency', 'Frequência de aparição'],
  'Porcentaje de respuestas en que aparece tu marca, por motor y en total.': [
    'Percentage of answers mentioning your brand, by engine and overall.',
    'Porcentagem de respostas que mencionam sua marca, por motor e no total.',
  ],
  'Participación relativa': ['Relative share', 'Participação relativa'],
  'Tu parte de las menciones de la categoría frente a tus competidores (share-of-voice). Se reporta aparte del Score.':
    [
      'Your share of category mentions against competitors (share of voice). Reported separately from the score.',
      'Sua participação nas menções da categoria frente à concorrência (share of voice). Informada separadamente do score.',
    ],
  'Percepción positiva': ['Positive perception', 'Percepção positiva'],
  'Porcentaje de menciones con tono positivo.': [
    'Percentage of mentions with a positive tone.',
    'Porcentagem de menções com tom positivo.',
  ],
  'Fuentes enlazadas': ['Linked sources', 'Fontes com links'],
  'Porcentaje de respuestas que enlazan tu sitio como fuente.': [
    'Percentage of answers linking to your website as a source.',
    'Porcentagem de respostas que incluem um link para seu site como fonte.',
  ],
  'Ranking promedio en lista': [
    'Average rank in lists',
    'Posição média em listas',
  ],
  'Tu lugar promedio cuando la respuesta lista varias marcas.': [
    'Your average position when an answer lists several brands.',
    'Sua posição média quando a resposta lista várias marcas.',
  ],
  'Ubicación en el texto': ['Position in the text', 'Localização no texto'],
  'En qué parte de la respuesta apareces: al inicio pesa más que al final.': [
    'Where you appear in the answer: the beginning carries more weight than the end.',
    'Onde você aparece na resposta: o início tem mais peso que o final.',
  ],
  'Primera cita': ['First citation', 'Primeira citação'],
  'Posición del primer link': [
    'Position of the first link',
    'Posição do primeiro link',
  ],
  'En qué lugar aparece el primer enlace a tu sitio entre las fuentes citadas.':
    [
      'Where the first link to your site appears among the cited sources.',
      'Onde aparece o primeiro link para seu site entre as fontes citadas.',
    ],
  'Servidor MCP': ['MCP server', 'Servidor MCP'],
  'Un copiloto dentro del dashboard: responde sobre tu cobertura, compara semanas y arma reportes en lenguaje natural. Plan Growth.':
    [
      'A copilot in the dashboard: asks about coverage, compares weeks and prepares reports in natural language. Growth plan.',
      'Um copiloto no dashboard: responde sobre cobertura, compara semanas e prepara relatórios em linguagem natural. Plano Growth.',
    ],
  'Conecta Claude, Cursor u otro cliente MCP a tus datos de visibilidad sin exportar planillas.':
    [
      'Connect Claude, Cursor or another MCP client to your visibility data without exporting spreadsheets.',
      'Conecte Claude, Cursor ou outro cliente MCP aos seus dados de visibilidade sem exportar planilhas.',
    ],
  'Cruza la visibilidad con las visitas que llegan desde ChatGPT, Perplexity y los demás motores.':
    [
      'Connect visibility with visits arriving from ChatGPT, Perplexity and other engines.',
      'Cruze a visibilidade com as visitas vindas do ChatGPT, Perplexity e outros motores.',
    ],
  'Ve tus consultas orgánicas junto a tu presencia en las respuestas generativas.':
    [
      'See organic queries alongside your presence in generative answers.',
      'Veja suas consultas orgânicas ao lado da sua presença nas respostas generativas.',
    ],
  '¿La IA te reconoce como una entidad única? Registros, datos estructurados y directorios consistentes.':
    [
      'Does AI recognize you as a unique entity? Consistent records, structured data and directories.',
      'A IA reconhece você como uma entidade única? Registros, dados estruturados e diretórios consistentes.',
    ],
  '¿Hay reseñas y casos verificables que un motor pueda citar?': [
    'Are there verifiable reviews and case studies an engine can cite?',
    'Há avaliações e casos verificáveis que um motor possa citar?',
  ],
  '¿Medios y fuentes de autoridad hablan de tu marca?': [
    'Do authoritative media and sources talk about your brand?',
    'Veículos e fontes de referência falam da sua marca?',
  ],
  '¿Tu marca aparece en las comunidades y conversaciones que los motores leen?':
    [
      'Does your brand appear in the communities and conversations engines read?',
      'Sua marca aparece nas comunidades e conversas que os motores leem?',
    ],
  'Esta semana': ['This week', 'Esta semana'],
  'Este mes': ['This month', 'Este mês'],
  'Este trimestre': ['This quarter', 'Este trimestre'],
  Técnico: ['Technical', 'Técnico'],
  Contenido: ['Content', 'Conteúdo'],
  Alto: ['High', 'Alto'],
  Medio: ['Medium', 'Médio'],
  Bajo: ['Low', 'Baixo'],
  'Permitir el acceso de los bots de búsqueda de IA en robots.txt': [
    'Allow AI search bots in robots.txt',
    'Permitir bots de busca de IA no robots.txt',
  ],
  'Publicar el marcado de organización con tus perfiles oficiales': [
    'Publish organization markup with your official profiles',
    'Publicar marcação de organização com seus perfis oficiais',
  ],
  'Responder las preguntas frecuentes donde hoy no apareces': [
    'Answer the common questions where you are missing today',
    'Responder às perguntas frequentes em que você não aparece hoje',
  ],
  'Ordenar tus fichas en directorios y plataformas de reseñas': [
    'Organize your directory and review platform listings',
    'Organizar seus perfis em diretórios e plataformas de avaliações',
  ],
  'Completar el sitemap con las páginas que importan': [
    'Complete your sitemap with key pages',
    'Completar o sitemap com as páginas relevantes',
  ],
  'Publicar una comparativa honesta frente a las alternativas': [
    'Publish an honest comparison with alternatives',
    'Publicar um comparativo honesto com as alternativas',
  ],
  'Conseguir cobertura en medios de autoridad de tu sector': [
    'Earn coverage in authoritative industry media',
    'Conseguir cobertura em veículos de referência do seu setor',
  ],
  'Acceso de los bots de IA': ['AI bot access', 'Acesso de bots de IA'],
  'Qué bots de búsqueda y de entrenamiento permite tu robots.txt.': [
    'Which search and training bots your robots.txt allows.',
    'Quais bots de busca e treinamento seu robots.txt permite.',
  ],
  Indexación: ['Indexing', 'Indexação'],
  'Si tus páginas clave están indexadas y sin bloqueos.': [
    'Whether your key pages are indexed and unblocked.',
    'Se suas páginas principais estão indexadas e sem bloqueios.',
  ],
  'Si el sitemap existe, está al día y lista las páginas que importan.': [
    'Whether your sitemap exists, is current and lists key pages.',
    'Se o sitemap existe, está atualizado e lista as páginas relevantes.',
  ],
  'Certificado válido y redirecciones correctas.': [
    'Valid certificate and correct redirects.',
    'Certificado válido e redirecionamentos corretos.',
  ],
  'Datos estructurados': ['Structured data', 'Dados estruturados'],
  'Organization, productos y preguntas frecuentes con schema.org válido.': [
    'Organization, products and FAQs with valid schema.org.',
    'Organization, produtos e perguntas frequentes com schema.org válido.',
  ],
  'Estructura semántica': ['Semantic structure', 'Estrutura semântica'],
  'Títulos, jerarquía de encabezados y textos alternativos en imágenes.': [
    'Titles, heading hierarchy and image alt text.',
    'Títulos, hierarquia de cabeçalhos e textos alternativos em imagens.',
  ],
  'Archivo para agentes y herramientas que lo leen.': [
    'A file for agents and tools that read it.',
    'Arquivo para agentes e ferramentas que o leem.',
  ],
  Velocidad: ['Speed', 'Velocidade'],
  'Resultados de PageSpeed en móvil y escritorio.': [
    'PageSpeed results on mobile and desktop.',
    'Resultados do PageSpeed em dispositivos móveis e computadores.',
  ],
  'FUENTE · GARTNER · 2024': [
    'SOURCE · GARTNER · 2024',
    'FONTE · GARTNER · 2024',
  ],
  'FUENTE · SIMILARWEB · 2026': [
    'SOURCE · SIMILARWEB · 2026',
    'FONTE · SIMILARWEB · 2026',
  ],
  'FUENTE · PEW RESEARCH CENTER · 2025': [
    'SOURCE · PEW RESEARCH CENTER · 2025',
    'FONTE · PEW RESEARCH CENTER · 2025',
  ],
  Caso: ['Case', 'Caso'],
  'Ver precios en {currency}': [
    'View prices in {currency}',
    'Ver preços em {currency}',
  ],
  'Precios en CLP, más IVA. Facturación mensual o anual con 15% de descuento.':
    [
      'Prices in CLP, excluding VAT. Monthly or annual billing with a 15% discount.',
      'Preços em CLP, sem IVA. Cobrança mensal ou anual com desconto de 15%.',
    ],
  'Precios en USD, más impuestos locales si aplican. Facturación mensual o anual con 15% de descuento.':
    [
      'Prices in USD, plus local taxes where applicable. Monthly or annual billing with a 15% discount.',
      'Preços em USD, mais impostos locais quando aplicáveis. Cobrança mensal ou anual com desconto de 15%.',
    ],
  'en las respuestas de IA?': ['in AI answers?', 'nas respostas de IA?'],
  'en {industry}?': ['in {industry}?', 'em {industry}?'],
  'Plan anual: 15% de descuento en Scout, Radar y Growth. Precios aproximados en USD; factura en USD para México, Colombia, Argentina, Perú, Uruguay y resto de LatAm. Precios + IVA u otros impuestos según jurisdicción.':
    [
      'Annual plan: 15% off Scout, Radar and Growth. Approximate USD prices; USD billing for Mexico, Colombia, Argentina, Peru, Uruguay and the rest of Latin America. VAT or local taxes apply.',
      'Plano anual: 15% de desconto em Scout, Radar e Growth. Preços aproximados em USD; cobrança em USD para México, Colômbia, Argentina, Peru, Uruguai e restante da América Latina. IVA ou impostos locais aplicáveis.',
    ],
  'Plan anual: 15% de descuento en Scout, Radar y Growth. Todos los precios en CLP; facturación en USD disponible para clientes fuera de Chile. Precios + IVA.':
    [
      'Annual plan: 15% off Scout, Radar and Growth. All prices in CLP; USD billing available outside Chile. Prices exclude VAT.',
      'Plano anual: 15% de desconto em Scout, Radar e Growth. Todos os preços em CLP; cobrança em USD disponível fora do Chile. Preços sem IVA.',
    ],
  'No dejes que la IA haga tu': [
    'Keep AI from making',
    'Não deixe a IA tornar',
  ],
  '¿Por qué necesito Bison si ya tengo analytics, SEO y herramientas de marketing?':
    [
      'Why do I need Bison if I already have analytics, SEO and marketing tools?',
      'Por que preciso do Bison se já tenho analytics, SEO e ferramentas de marketing?',
    ],
  'Porque ninguno cubre la capa que cubre Bison. Tu analítica (GA4) mide el tráfico humano de tu web, pero es ciega a lo que la IA dice de ti y a si te cita en sus respuestas. El SEO optimiza tu ranking en una lista de enlaces, no que te citen o recomienden dentro de una respuesta generada. Y tus herramientas de contenido producen material, pero no miden ni optimizan tu citación en los LLMs ni validan lo que la IA afirma de tu marca. Bison reúne el SEO y la visibilidad en IA en una sola plataforma: audita la base técnica de tu sitio —robots.txt, indexación, sitemap, schema.org, llms.txt, velocidad— y lee Search Console, junto a la capa nueva que esas herramientas no cubren: visibilidad en IA, Brand Brain, generación de contenido y medición.':
    [
      'Your analytics measures human traffic but cannot see what AI says about you or whether it cites you. SEO improves your position in search links, while content tools create material without measuring or optimizing LLM citations or checking AI claims. Bison combines SEO and AI visibility: it audits robots.txt, indexing, sitemaps, schema.org, llms.txt and speed, reads Search Console, and adds AI visibility, Brand Brain, content generation and measurement.',
      'Sua ferramenta de analytics mede o tráfego humano, mas não vê o que a IA diz sobre você nem se cita sua marca. O SEO melhora sua posição nos links de busca, enquanto as ferramentas de conteúdo produzem material sem medir ou otimizar citações em LLMs nem verificar afirmações da IA. O Bison reúne SEO e visibilidade em IA: audita robots.txt, indexação, sitemap, schema.org, llms.txt e velocidade, lê o Search Console e adiciona visibilidade em IA, Brand Brain, geração de conteúdo e medição.',
    ],
  '¿Cuánto demora ver resultados en ChatGPT o Gemini?': [
    'How long does it take to see results in ChatGPT or Gemini?',
    'Quanto tempo leva para ver resultados no ChatGPT ou Gemini?',
  ],
  'En modelos con búsqueda web, la indexación de datos estructurados es rápida —24 a 48 horas. Pero la autoridad es progresiva: marcas emergentes pueden ganar visibilidad inicial rápido al llenar vacíos semánticos que los líderes del mercado ignoran, aunque consolidarse como fuente preferente requiere consistencia técnica de 4 a 8 semanas.':
    [
      'In models with web search, structured data can be indexed in 24–48 hours. Authority builds progressively: emerging brands can gain early visibility by filling semantic gaps that market leaders overlook. Becoming a preferred source requires 4–8 weeks of technical consistency.',
      'Em modelos com busca na web, dados estruturados podem ser indexados em 24–48 horas. A autoridade cresce progressivamente: marcas emergentes podem ganhar visibilidade inicial preenchendo lacunas semânticas ignoradas pelos líderes. Consolidar-se como fonte preferida exige 4–8 semanas de consistência técnica.',
    ],
  '¿Qué métricas veo y cómo se conectan con el negocio?': [
    'Which metrics do I see, and how do they connect with the business?',
    'Quais métricas vejo e como elas se conectam ao negócio?',
  ],
  'En la IA medimos tu Share of Model (con qué frecuencia te citan frente a tu competencia), el sentimiento de cada mención, tu posición en la respuesta y la cobertura por motor — todo en un dashboard que se actualiza cada semana. Para conectarlo con el negocio, nos integramos con Google Analytics (GA4) y separamos el tráfico humano del tráfico de IA, viendo qué visitas y conversiones llegan desde ChatGPT, Gemini o Perplexity.':
    [
      'We measure Share of Model (how often you are cited against competitors), sentiment, position in answers and engine coverage in a dashboard updated weekly. Google Analytics (GA4) integration separates human and AI traffic and shows visits and conversions arriving from ChatGPT, Gemini or Perplexity.',
      'Medimos Share of Model (com que frequência você é citado frente à concorrência), sentimento, posição nas respostas e cobertura por motor em um dashboard atualizado semanalmente. A integração com Google Analytics (GA4) separa o tráfego humano do tráfego de IA e mostra visitas e conversões vindas do ChatGPT, Gemini ou Perplexity.',
    ],
  '¿Necesito instalar algo en mi sitio para usar la plataforma?': [
    'Do I need to install anything on my website?',
    'Preciso instalar algo no meu site?',
  ],
  'No. Operamos 100% desde afuera — sin SDK, sin snippets, sin riesgo en producción. Lo único que recomendamos —porque sí impacta tu visibilidad— es publicar tu archivo llms.txt y dejar bien implementado tu schema.org; eso lo auditamos nosotros y te damos las instrucciones exactas. Y si quieres integración más profunda, exponemos API REST, webhooks para alertas en tiempo real y un servidor MCP para operar desde Claude, Cursor o tu propio agente.':
    [
      'No. We work externally, without SDKs, snippets or production risk. We recommend publishing llms.txt and implementing schema.org properly because they affect visibility; we audit both and provide exact instructions. For deeper integration, we offer a REST API, real-time alert webhooks and an MCP server for Claude, Cursor or your own agent.',
      'Não. Operamos externamente, sem SDKs, snippets ou risco em produção. Recomendamos publicar llms.txt e implementar schema.org corretamente porque afetam a visibilidade; auditamos ambos e fornecemos instruções exatas. Para integrações mais profundas, oferecemos API REST, webhooks de alertas em tempo real e servidor MCP para Claude, Cursor ou seu próprio agente.',
    ],
  '¿Qué es el Brand Brain y por qué importa?': [
    'What is Brand Brain, and why does it matter?',
    'O que é Brand Brain e por que ele importa?',
  ],
  'El Brand Brain es la fuente de verdad centralizada e interna de tu marca dentro de Bison: entidades, productos, FAQs, comparativas y fuentes verificables. Bison lo mantiene y lo proyecta a los motores en los formatos que los LLMs leen de forma nativa. Cumple dos funciones: valida lo que la IA dice de ti —corrigiendo alucinaciones sobre precios, productos o atributos— y alimenta la generación de contenido con datos reales. Lo que el modelo termina sabiendo de ti es tu "huella en los modelos"; el Brand Brain es el activo interno que la construye.':
    [
      'Brand Brain is your centralized internal source of truth in Bison: entities, products, FAQs, comparisons and verifiable sources. Bison maintains it and presents it to engines in formats LLMs read natively. It validates AI statements, helping correct hallucinations about prices, products or attributes, and supplies real data for content generation. It is the internal asset that builds your footprint in AI models.',
      'O Brand Brain é a fonte de verdade interna e centralizada da sua marca no Bison: entidades, produtos, FAQs, comparativos e fontes verificáveis. O Bison o mantém e apresenta aos motores nos formatos que os LLMs leem nativamente. Ele valida afirmações da IA, ajudando a corrigir alucinações sobre preços, produtos ou atributos, e fornece dados reais para gerar conteúdo. É o ativo interno que constrói sua presença nos modelos de IA.',
    ],
  '¿Pueden implementar por nosotros?': [
    'Can you implement the changes for us?',
    'Vocês podem implementar por nós?',
  ],
  'Sí, en el plan Enterprise. Nuestro equipo escribe la entrada de Wikipedia, gestiona prensa Tier-1, estructura las reseñas, publica el contenido y configura los webhooks e integraciones técnicas. Tu equipo aprueba; nosotros ejecutamos.':
    [
      'Yes, on Enterprise. Our team writes Wikipedia entries, manages Tier-1 press, structures reviews, publishes content and configures webhooks and technical integrations. Your team approves; we execute.',
      'Sim, no Enterprise. Nossa equipe escreve páginas da Wikipédia, gerencia imprensa Tier-1, estrutura avaliações, publica conteúdo e configura webhooks e integrações técnicas. Sua equipe aprova; nós executamos.',
    ],
  '¿Qué es Bison Agents? ¿Cómo funciona?': [
    'What is Bison Agents, and how does it work?',
    'O que é Bison Agents e como funciona?',
  ],
  'Bison Agents es la plataforma SaaS de AEO (Answer Engine Optimization) y GEO (Generative Engine Optimization) para marcas y agencias de LatAm — el sistema operativo de AEO/GEO que cubre el ciclo completo: mide tu visibilidad en ChatGPT, Gemini, Claude y Google AIO, diagnostica brechas con un score 0–100 y genera el contenido para cerrarlas, listo para que tu equipo lo publique. El nombre "Agents" viene de los agentes que operan en la plataforma: monitoreo, optimización y otros disponibles para los clientes.':
    [
      'Bison Agents is the AEO (Answer Engine Optimization) and GEO (Generative Engine Optimization) SaaS platform for Latin American brands and agencies. It measures visibility in ChatGPT, Gemini, Claude and Google AIO, diagnoses gaps from 0–100 and generates content to close them, ready for your team to publish. Agents refers to the monitoring, optimization and other agents available to customers within the platform.',
      'O Bison Agents é a plataforma SaaS de AEO (Answer Engine Optimization) e GEO (Generative Engine Optimization) para marcas e agências da América Latina. Mede a visibilidade no ChatGPT, Gemini, Claude e Google AIO, diagnostica lacunas de 0 a 100 e gera conteúdo para fechá-las, pronto para sua equipe publicar. Agents se refere aos agentes de monitoramento, otimização e outros disponíveis aos clientes na plataforma.',
    ],
  '¿Cómo elijo entre Scout, Radar, Growth o Enterprise?': [
    'How do I choose between Scout, Radar, Growth and Enterprise?',
    'Como escolho entre Scout, Radar, Growth e Enterprise?',
  ],
  'Scout es para probar el monitoreo en un solo motor (ChatGPT) antes de comprometerte con más. Radar suma diagnóstico completo y monitoreo multi-motor para medir antes de invertir en ejecución. Growth suma lo que mueve la aguja —generación de contenido, agente integrado, servidor MCP y alertas— y es el que firma la mayoría. Enterprise es para cuando necesitas mayor volumen de prompts y motores, o que el equipo Bison ejecute y publique por ti de punta a punta, con un SLA dedicado. En resumen: si quieres asomarte con el mínimo compromiso, empieza en Scout; si quieres el diagnóstico completo primero, sube a Radar; si vas a ejecutar, parte en Growth; si necesitas escala o ejecución completa, es Enterprise. Puedes subir de plan cuando quieras.':
    [
      'Scout lets you try monitoring on one engine (ChatGPT). Radar adds a complete diagnosis and multi-engine monitoring before you invest in execution. Growth adds content generation, the integrated agent, MCP server and alerts. Enterprise provides higher prompt and engine volumes or end-to-end execution and publishing by Bison with a dedicated SLA. Start with Scout to explore, Radar for a full diagnosis, Growth to execute or Enterprise for scale and full implementation. You can upgrade anytime.',
      'O Scout permite testar o monitoramento em um motor (ChatGPT). O Radar adiciona diagnóstico completo e monitoramento em vários motores antes de investir na execução. O Growth adiciona geração de conteúdo, agente integrado, servidor MCP e alertas. O Enterprise oferece mais prompts e motores ou execução e publicação completas pelo Bison com SLA dedicado. Comece com Scout para experimentar, Radar para um diagnóstico completo, Growth para executar ou Enterprise para escala e implementação completa. Você pode mudar de plano quando quiser.',
    ],
  '¿Hay descuento por contrato anual?': [
    'Is there an annual billing discount?',
    'Há desconto no pagamento anual?',
  ],
  'Sí. Los planes Scout, Radar y Growth tienen 15% de descuento si pagas anualmente. El plan Enterprise se estructura como retainer trimestral con precio a medida según volumen y mercados.':
    [
      'Yes. Scout, Radar and Growth offer 15% off when paid annually. Enterprise is a quarterly retainer priced for your volume and markets.',
      'Sim. Scout, Radar e Growth oferecem 15% de desconto no pagamento anual. O Enterprise é um contrato trimestral com preço conforme o volume e os mercados.',
    ],
  '¿Qué significa "30 prompts" en el plan Radar?': [
    'What does “30 prompts” mean on Radar?',
    'O que significa “30 prompts” no Radar?',
  ],
  'Son 30 preguntas únicas que rastreamos cada semana en los motores generativos. Cada una se ejecuta 3–5 veces por motor para reducir la varianza estadística, lo que genera ~1.600 respuestas analizadas por mes en la configuración base. Esa cifra sube con cada motor o paquete de prompts que agregues desde la sección de personalización (o a medida en Enterprise).':
    [
      'These are 30 unique questions tracked weekly across generative engines. Each runs 3–5 times per engine to reduce statistical variance, producing about 1,600 analyzed answers per month in the base configuration. The total grows when you add engines or prompt packages through customization or Enterprise.',
      'São 30 perguntas únicas monitoradas semanalmente nos motores generativos. Cada uma é executada 3–5 vezes por motor para reduzir a variância estatística, gerando cerca de 1.600 respostas analisadas por mês na configuração base. O total cresce quando você adiciona motores ou pacotes de prompts pela personalização ou Enterprise.',
    ],
  '¿Puedo sumar motores o prompts sin cambiar de plan?': [
    'Can I add engines or prompts without changing plans?',
    'Posso adicionar motores ou prompts sem mudar de plano?',
  ],
  'Sí. Puedes agregar motores adicionales o paquetes de prompts sobre tu plan base; el precio varía según la combinación, como muestra la matriz de personalización. Hasta 200 prompts/sem los contratas directo desde la web; por encima no hay tope, pero lo armamos a medida contigo en Enterprise.':
    [
      'Yes. Add engines or prompt packages to your base plan; prices depend on the combination shown in the customization matrix. Up to 200 prompts/week can be purchased directly on the website. Higher volumes have no fixed limit and are arranged with you through Enterprise.',
      'Sim. Adicione motores ou pacotes de prompts ao seu plano base; o preço depende da combinação mostrada na matriz de personalização. Até 200 prompts/semana podem ser contratados diretamente no site. Volumes maiores não têm limite fixo e são montados com você no Enterprise.',
    ],
  '¿En qué monedas y medios de pago facturan?': [
    'Which currencies and payment methods do you accept?',
    'Quais moedas e meios de pagamento vocês aceitam?',
  ],
  'CLP para clientes en Chile y USD para el resto de LatAm, vía transferencia bancaria o tarjeta de crédito. Los planes anuales se cobran al inicio del período; los mensuales, el mismo día cada mes. ¿Necesitas otra moneda o tienes requisitos de tesorería? Escríbenos antes de contratar.':
    [
      'CLP for customers in Chile and USD for the rest of Latin America, by bank transfer or credit card. Annual plans are charged at the start of the period; monthly plans on the same day each month. Contact us before subscribing if you need another currency or have treasury requirements.',
      'CLP para clientes no Chile e USD para o restante da América Latina, por transferência bancária ou cartão de crédito. Planos anuais são cobrados no início do período; os mensais, no mesmo dia de cada mês. Fale conosco antes de contratar se precisar de outra moeda ou tiver requisitos financeiros.',
    ],
  '¿Puedo cancelar en cualquier momento?': [
    'Can I cancel anytime?',
    'Posso cancelar quando quiser?',
  ],
  'Sí. No hay contratos de permanencia. Cancelas cuando quieras sin penalización — el siguiente período no se cobra.':
    [
      'Yes. There is no lock-in. Cancel anytime without a penalty and the next billing period will not be charged.',
      'Sim. Não há fidelidade. Cancele quando quiser, sem multa, e o próximo período não será cobrado.',
    ],
  '¿Trabajan con agencias o con varias marcas a la vez?': [
    'Do you work with agencies or multiple brands?',
    'Vocês trabalham com agências ou várias marcas?',
  ],
  'Sí. Hay workspaces multi-marca para agencias que gestionan varios clientes desde una sola cuenta: cada marca con su propio diagnóstico, reportes y permisos, más una vista de conjunto para el equipo de la agencia. Escríbenos contándonos cuántas marcas manejas y te orientamos sobre el formato y el precio.':
    [
      'Yes. Agencies can manage several customers from one account using multi-brand workspaces. Each brand has its own diagnosis, reports and permissions, plus an overview for the agency team. Tell us how many brands you manage so we can recommend a format and price.',
      'Sim. Agências podem gerenciar vários clientes em uma conta com workspaces de múltiplas marcas. Cada marca tem diagnóstico, relatórios e permissões próprios, além de uma visão geral para a equipe da agência. Conte quantas marcas você gerencia para recomendarmos o formato e o preço.',
    ],
};
